"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldCopyColumnDefault = exports.resolveColumnFormulaCells = exports.preprocessFormula = exports.normaliseResult = exports.isRowCellFormula = exports.isFormulaString = exports.isDateText = exports.isCellFormula = exports.isBlankCell = exports.isAmbiguousText = exports.guardFunctionArgs = exports.getTableLookupWithColumnFormulas = exports.getResolvedCellsByIndex = exports.getOrderedRows = exports.getDisplayCellValue = exports.getColumnFormula = exports.getCellEditValue = exports.filterLookupColumns = exports["default"] = exports.__testing = exports.TEXT_SAFE_ARGS = exports.LIMITS = exports.FUNCTION_ARG_CAPS = exports.FORMULA_ERROR = exports.DIRECT_TEXT_ARGS = exports.DERIVED_TEXT_ARGS = exports.CELL_DATE_ARGS = exports.BLANK_STAYS_EMPTY = exports.BLANK_SKIPPING_ARGS = exports.ANY_ARG = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _hotFormulaParser = require("@builttocreate/hot-formula-parser");
var _tableHelper = require("./tableHelper");
var _FieldTableColumnTypes = _interopRequireDefault(require("./constants/FieldTableColumnTypes"));
var _FieldTableCustomColumnIds = _interopRequireDefault(require("./constants/FieldTableCustomColumnIds"));
var _FormulaFixedArity = _interopRequireDefault(require("./constants/FormulaFixedArity"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2["default"])(t); if (r) { var s = (0, _getPrototypeOf2["default"])(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2["default"])(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * Column-level formulas for table text columns (NO-2347).
 *
 * A text column may carry an Excel-like formula in its default value (`tableColumns[].value`,
 * for instance `=A*B`). Every blank cell under that column displays the calculated result and
 * shows the formula when focused. Nothing is ever written to `row.cells`: the result lives only
 * in memory for the duration of a render, exactly like the existing cell-level formulas.
 *
 * Stored cell formulas are routed by shape (isA1OnlyFormula in tableHelper.js). A formula that only
 * uses A1-style references (=SUM(A1+B1), in any case) stays with the cell-level engine
 * (`generateTableLookup`), exactly as before. Any other shape in a text cell (=sum(a,b), =PI())
 * is a "row-path" cell formula: this module evaluates it for its own row, like a column formula
 * scoped to one cell. This module layers on the cell-level engine in three passes (see
 * getTableLookupWithColumnFormulas):
 *
 *   1. legacy  = generateTableLookup(rows, columns)            A1-only cell formulas
 *   2. overlay = resolveColumnFormulaCells(rows, columns, legacy)  blank cells under a column formula
 *                                                               and row-path cell formulas
 *   3. final   = generateTableLookup(rows + overlay, columns)   A1-only cell formulas can now read
 *                                                               the overlay results
 *
 * Inside pass 2, an A1-only cell whose inputs lead to an overlay cell ("dirty") is evaluated on
 * demand with the cell engine's own getFormulaResult, sharing one memo and one cycle stack with the
 * column formulas, so a chain can cross between the engines any number of times. Every other A1
 * cell is read from pass 1, exactly as before.
 *
 * A chain longer than LIMITS.depth is finished in steps (resolveRoot): a walk that would recurse
 * deeper resolves its deepest cell first and then retries, so the value never depends on the depth
 * limit. A cell past the soft time budget is Error, never a value computed before its inputs.
 *
 * An empty cell (blank text, dropdown or multiSelect, or outside the table) reaches a formula as
 * BLANK: skipped by list functions, 0 in arithmetic and in a single number argument, '' wherever
 * text is read. Where '' gave a value before, the value is unchanged.
 *
 * Precedence for one text cell: row-path cell formula, then A1-only cell formula, then column
 * formula (blank cell only), then the stored literal.
 */

var FORMULA_ERROR = exports.FORMULA_ERROR = 'Error';

/**
 * Resource caps for one column-formula evaluation. A column formula runs once per row, so one
 * pathological default would otherwise cost the whole table. These never reject a function by
 * name (every function a cell accepts is accepted here); they bound argument sizes only.
 *
 * softTimeBudgetMs is a soft budget: once a table resolution has spent it, every remaining cell
 * is reported as Error instead of being evaluated. JavaScript cannot interrupt a built-in that is
 * already running, so this degrades gracefully after a slow cell; the caps are the real guard.
 */
var LIMITS = exports.LIMITS = {
  formulaLength: 1000,
  rangeCells: 10000,
  //How many column or row-path cells one walk recurses through before it resumes from the deepest
  //one (resolveRoot). It bounds JavaScript recursion, not the length of a chain.
  depth: 50,
  resultLength: 10000,
  reptCount: 10000,
  totalWork: 100000,
  softTimeBudgetMs: 2000,
  //Direct cell text at a position this change newly opens to it (see DIRECT_TEXT_ARGS). Text that
  //came out of a nested function is not held to it: it reaches those positions today, uncapped.
  textArgLength: 256
};

/**
 * The legacy engine addresses columns A..Z only (String.fromCharCode(65 + index)). Column
 * formulas honour the same ceiling for letter references so a letter can never mean a column the
 * other engine cannot see. Columns past Z are reachable by title, [bracket] or id.
 */
var LEGACY_LETTER_COLUMNS = 26;
var isLetterAddressable = function isLetterAddressable(index) {
  return Number.isInteger(index) && index >= 0 && index < LEGACY_LETTER_COLUMNS;
};

/** Marker stored in the title index when two or more columns share a title. */
var AMBIGUOUS = -1;
var REFERENCE_TOKEN_PREFIX = 'JFREF_';
var UNKNOWN_REFERENCE_TOKEN = "".concat(REFERENCE_TOKEN_PREFIX, "UNKNOWN");
var HEX_ID_LENGTH = 24;
var HEX_ID_REGEXP = /^[0-9a-fA-F]{24}$/;
var IDENTIFIER_START_REGEXP = /[A-Za-z_]/;
var IDENTIFIER_PART_REGEXP = /[A-Za-z0-9_.]/;
//Excel treats 0x10 / 0b101 / 0o17 as text. Number() reads them as 16 / 5 / 15, so they are
//excluded from numericValue and fall through to the ambiguous branch instead of silently
//becoming numbers.
var RADIX_LITERAL_REGEXP = /^[+-]?0[bxo]/i;

// ---------------------------------------------------------------------------
// Small helpers shared with the SDK
// ---------------------------------------------------------------------------

/**
 * A formula is any string whose first non-space character is "=" followed by something.
 */
var isFormulaString = exports.isFormulaString = function isFormulaString(value) {
  return typeof value === 'string' && /^\s*=\S/.test(value);
};

/**
 * A cell holds a formula when its trimmed text starts with "=". Looser than isFormulaString
 * (which needs a non-space after "=") because the cell-level engine has always accepted
 * "= SUM(A1+B1)".
 */
var isCellFormula = exports.isCellFormula = function isCellFormula(value) {
  return typeof value === 'string' && value.trim().length > 1 && value.trim().charAt(0) === '=';
};

/**
 * A stored cell formula this module evaluates for its own row (the "row path"): any cell formula
 * the cell-level engine does not own. Text columns only, the same rule column formulas follow, so a
 * barcode or block value starting with "=" stays a literal.
 */
var isRowCellFormula = exports.isRowCellFormula = function isRowCellFormula(value, column) {
  return !!column && column.type === _FieldTableColumnTypes["default"].text && isCellFormula(value) && !(0, _tableHelper.isA1OnlyFormula)(value);
};

/**
 * Only a truly empty cell opts into the column formula. Whitespace is something the user typed
 * and is a literal; a numeric 0 is a literal.
 */
var isBlankCell = exports.isBlankCell = function isBlankCell(value) {
  return value === undefined || value === null || value === '';
};

/**
 * The column formula of a text column, or null. Only text columns take part (a barcode column
 * with a "=..." default keeps that value as a plain literal default, as today).
 */
var getColumnFormula = exports.getColumnFormula = function getColumnFormula(column) {
  return column && !column.deleted && column.type === _FieldTableColumnTypes["default"].text && isFormulaString(column.value) ? column.value.trim() : null;
};

/**
 * What an editor should show for a cell: the stored value, except a blank cell under a column
 * formula, which shows the column formula. Never returns a calculated value.
 */
var getCellEditValue = exports.getCellEditValue = function getCellEditValue(cell, column) {
  return isBlankCell(cell) ? getColumnFormula(column) || cell : cell;
};

/**
 * Whether a column's default value should be copied into a newly created row's cells. Plain
 * defaults are copied exactly as they are today; a formula default stays on the column.
 */
var shouldCopyColumnDefault = exports.shouldCopyColumnDefault = function shouldCopyColumnDefault(column) {
  return !getColumnFormula(column);
};

/**
 * The blurred (display) value of one cell for every consumer. The legacy lookup turns a stored
 * text 0 and whitespace-only text into "". Only in that case is the stored literal shown instead;
 * ordinary text keeps the legacy lookup's display (which trims), so nothing else on screen changes.
 */
var getDisplayCellValue = exports.getDisplayCellValue = function getDisplayCellValue(rawCell, column, lookupValue) {
  var isTextLiteral = !!column && column.type === _FieldTableColumnTypes["default"].text && !isBlankCell(rawCell) && !isFormulaString(rawCell);
  if (isTextLiteral && (lookupValue === '' || lookupValue === null || lookupValue === undefined)) return rawCell;
  return lookupValue;
};

/**
 * The same column filter generateTableLookup applies, so operand letters line up between the
 * two engines.
 */
var filterLookupColumns = exports.filterLookupColumns = function filterLookupColumns(columns) {
  var parsedColumns = columns;
  if (typeof parsedColumns === 'string') parsedColumns = JSON.parse(parsedColumns);
  if (!Array.isArray(parsedColumns)) return [];
  return parsedColumns.filter(function (column) {
    return column && !column.deleted && column._id !== _FieldTableCustomColumnIds["default"].rowMenu && column._id !== _FieldTableCustomColumnIds["default"].rowNumber;
  });
};

/**
 * The one row list every consumer resolves over: the rows the grid renders first, in its order,
 * then every other non-deleted row appended once by array index.
 *
 * sortRows alone drops rows the rowOrder forgot and, for a duplicated id, keeps only the LAST
 * occurrence (its lookup is overwritten). This walks by physical index so no row is ever lost,
 * while the prefix is exactly what the grid renders: for each id it takes the same last occurrence
 * sortRows would.
 */
var getOrderedRows = exports.getOrderedRows = function getOrderedRows(rows, rowOrder) {
  var activeRows = (0, _tableHelper.getRows)(rows);
  var cleanedRowOrder = (0, _tableHelper.getCleanedRowOrder)(rowOrder, activeRows);
  var lastIndexById = {};
  activeRows.forEach(function (row, index) {
    lastIndexById[row._id] = index;
  });
  var consumed = new Set();
  var ordered = [];
  cleanedRowOrder.forEach(function (rowId) {
    var index = lastIndexById[rowId];
    if (index !== undefined && !consumed.has(index)) {
      consumed.add(index);
      ordered.push(activeRows[index]);
    }
  });
  activeRows.forEach(function (row, index) {
    if (!consumed.has(index)) {
      consumed.add(index);
      ordered.push(row);
    }
  });
  return ordered;
};

// ---------------------------------------------------------------------------
// Reference index and formula preprocessing
// ---------------------------------------------------------------------------

var upper = function upper(value) {
  return String(value).trim().toUpperCase();
};

/**
 * Maps a formula may use to name a column. Keys are uppercased so lookups are case-insensitive.
 * A title shared by two or more columns is recorded as AMBIGUOUS: a formula using it shows Error
 * rather than silently picking one of them.
 */
var buildReferenceIndex = function buildReferenceIndex(columns) {
  var byId = {};
  var byTitle = {};
  columns.forEach(function (column, index) {
    if (column._id !== undefined && column._id !== null) byId[upper(column._id)] = index;
    if (typeof column.title === 'string' && column.title.trim() !== '') {
      var key = upper(column.title);
      byTitle[key] = key in byTitle ? AMBIGUOUS : index;
    }
  });
  return {
    byId: byId,
    byTitle: byTitle
  };
};
var referenceToken = function referenceToken(index) {
  return "".concat(REFERENCE_TOKEN_PREFIX).concat((0, _hotFormulaParser.columnIndexToLabel)(index));
};

/**
 * Resolve the text inside [brackets]: column id first, then a unique title.
 */
var lookupBracket = function lookupBracket(refs, content) {
  var key = upper(content);
  if (refs.byId[key] !== undefined) return refs.byId[key];
  var titleIndex = refs.byTitle[key];
  if (titleIndex !== undefined && titleIndex !== AMBIGUOUS) return titleIndex;
  return null;
};

/**
 * Resolve a bare identifier the parser hands to callVariable, or one the preprocessor sees.
 * Priority: substitution token, column id, unique title, single letter A..Z. A cell address
 * (one letter and a row number) never gets here: preprocessFormula keeps it an address.
 */
var lookupColumn = function lookupColumn(refs, name, columnCount) {
  if (name.startsWith(REFERENCE_TOKEN_PREFIX)) {
    var label = name.slice(REFERENCE_TOKEN_PREFIX.length);
    if (label === 'UNKNOWN') return null;
    var index = (0, _hotFormulaParser.columnLabelToIndex)(label);
    return index >= 0 && index < columnCount ? index : null;
  }
  if (refs.byId[name] !== undefined) return refs.byId[name];
  var titleIndex = refs.byTitle[name];
  if (titleIndex === AMBIGUOUS) return null;
  if (titleIndex !== undefined) return titleIndex;
  if (/^[A-Z]$/.test(name)) {
    var _index = name.charCodeAt(0) - 65;
    return _index < columnCount ? _index : null;
  }
  return null;
};

/**
 * Rewrite a formula into something the parser's lexer can read, without touching quoted strings:
 *
 *  - strip the leading "="
 *  - 24-hex column ids            -> JFREF_<Letters>   (an id may start with a digit, and the
 *                                                        lexer would otherwise split it into cells)
 *  - [Bracketed id or title]      -> JFREF_<Letters>
 *  - an identifier that is a known id or a unique title -> JFREF_<Letters> (id/title beat letters)
 *  - every other identifier       -> UPPERCASE         (sum -> SUM, a1 -> A1; the parser's
 *                                                        variables and custom functions are
 *                                                        case-sensitive, its built-ins are not)
 *  - ".5"                         -> "0.5"             (the parser throws on a bare decimal)
 *
 * The substitution token is letters only so the lexer reads it as a VARIABLE (COL0 would lex as
 * a cell reference).
 */
var preprocessFormula = exports.preprocessFormula = function preprocessFormula(formula) {
  var refs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    byId: {},
    byTitle: {}
  };
  var source = String(formula).trim();
  if (source.charAt(0) === '=') source = source.slice(1);
  if (source.length > LIMITS.formulaLength) throw new Error('formula too long');
  var output = '';
  var i = 0;
  var prevOutputChar = function prevOutputChar() {
    return output.length > 0 ? output.charAt(output.length - 1) : '';
  };
  var isIdentifierPart = function isIdentifierPart(_char) {
    return _char !== '' && IDENTIFIER_PART_REGEXP.test(_char);
  };
  while (i < source.length) {
    var _char2 = source.charAt(i);
    if (_char2 === '"' || _char2 === "'") {
      // Quoted string: copied verbatim, including its case. The lexer accepts \" inside "..."
      var quote = _char2;
      var j = i + 1;
      while (j < source.length && source.charAt(j) !== quote) {
        j += source.charAt(j) === '\\' ? 2 : 1;
      }
      output += source.slice(i, j + 1);
      i = j + 1;
    } else if (_char2 === '[' && source.indexOf(']', i + 1) !== -1) {
      // [Bracketed id or title]
      var close = source.indexOf(']', i + 1);
      var index = lookupBracket(refs, source.slice(i + 1, close));
      output += index === null ? UNKNOWN_REFERENCE_TOKEN : referenceToken(index);
      i = close + 1;
    } else if (_char2 === '.' && /[0-9]/.test(source.charAt(i + 1) || '') && !isIdentifierPart(prevOutputChar())) {
      // Bare decimal such as .5 -> 0.5 (only when it starts a number)
      output += '0.';
      i += 1;
    } else if ((IDENTIFIER_START_REGEXP.test(_char2) || /[0-9]/.test(_char2)) && !isIdentifierPart(prevOutputChar())) {
      // A token that starts with a letter, underscore or digit: could be an id, a title, a cell
      // reference, a function name or a number.
      var _j = i;
      while (_j < source.length && isIdentifierPart(source.charAt(_j))) {
        _j += 1;
      }
      var token = source.slice(i, _j);
      var key = token.toUpperCase();
      var startsLikeIdentifier = IDENTIFIER_START_REGEXP.test(_char2);
      var k = _j;
      while (k < source.length && source.charAt(k) === ' ') {
        k += 1;
      }
      var isFunctionCall = source.charAt(k) === '(';
      var isKnownId = refs.byId[key] !== undefined && (startsLikeIdentifier || token.length === HEX_ID_LENGTH && HEX_ID_REGEXP.test(token));

      //A1 syntax is reserved for cell addresses, with the same definition the cell engine's router
      //uses. Without this a column titled "A1" turned =A1 into "this row" in a column default, while
      //the same formula stored in a cell meant row 1. A look-alike title or id is reached as [A1].
      var isCellAddress = startsLikeIdentifier && (0, _tableHelper.isA1Reference)(token);
      if (!isFunctionCall && isKnownId && !isCellAddress) {
        output += referenceToken(refs.byId[key]);
      } else if (!isFunctionCall && !isCellAddress && startsLikeIdentifier && refs.byTitle[key] !== undefined) {
        output += refs.byTitle[key] === AMBIGUOUS ? UNKNOWN_REFERENCE_TOKEN : referenceToken(refs.byTitle[key]);
      } else if (startsLikeIdentifier) {
        output += key;
      } else {
        output += token; // a number
      }
      i = _j;
    } else {
      output += _char2;
      i += 1;
    }
  }
  return output;
};

// ---------------------------------------------------------------------------
// Function argument caps
// ---------------------------------------------------------------------------

var toNumberArg = function toNumberArg(value) {
  if (typeof value === 'number') return value;
  if (typeof value === 'string' && value.trim() !== '' && !Number.isNaN(Number(value))) return Number(value);
  return NaN;
};
var toDateArg = function toDateArg(value) {
  if (value instanceof Date) return value;
  if (typeof value === 'number') return new Date(Math.round((value - 25569) * 86400 * 1000)); // Excel serial day
  if (typeof value === 'string') {
    var parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }
  return null;
};

/**
 * Functions whose cost grows with a scalar argument, and the cap applied before the built-in
 * runs. Names in this table follow formulajs. Everything else in the parser's list is either
 * constant time or bounded by the array caps in guardFunctionArgs.
 */
var FUNCTION_ARG_CAPS = exports.FUNCTION_ARG_CAPS = [{
  names: ['FACT', 'FACTDOUBLE'],
  arg: 0,
  max: 170,
  reason: 'above 170 the result is Infinity anyway; the loop is O(n)'
}, {
  names: ['MULTINOMIAL'],
  sumOfArgs: true,
  max: 170,
  reason: 'O(sum of args)'
}, {
  names: ['COMBIN', 'COMBINA', 'PERMUT', 'PERMUTATIONA'],
  arg: 0,
  max: 1000,
  reason: 'O(n) loops per row'
}, {
  names: ['ROMAN'],
  arg: 0,
  max: 3999,
  reason: "Excel's own ROMAN limit; the loop is linear in the value"
}, {
  names: ['ARABIC'],
  arg: 0,
  maxLength: 20,
  reason: 'linear in the string length'
}, {
  names: ['REPT'],
  arg: 1,
  max: LIMITS.reptCount,
  reason: 'builds a string of that length'
}, {
  names: ['SERIESSUM'],
  arg: 3,
  maxLength: 1000,
  reason: 'linear in the coefficient count'
}, {
  names: ['NETWORKDAYS', 'DAYS360', 'YEARFRAC'],
  daySpan: [0, 1],
  max: 36500,
  reason: 'formulajs walks the span day by day'
},
//WORKDAY's second argument is a day COUNT, not an end date, so it cannot share the daySpan rule above
{
  names: ['WORKDAY'],
  arg: 1,
  max: 36500,
  reason: 'arg 1 is a day count, not a date; formulajs walks it day by day'
}, {
  names: ['IPMT', 'PPMT'],
  arg: 1,
  max: 10000,
  reason: 'period loops'
}, {
  names: ['CUMIPMT', 'CUMPRINC'],
  arg: 4,
  max: 10000,
  reason: 'loops from the start to the end period'
}, {
  names: ['BASE', 'DEC2BIN', 'DEC2HEX', 'DEC2OCT'],
  arg: 0,
  max: Math.pow(2, 31),
  reason: 'string building is linear in bit length'
}, {
  names: ['DECIMAL', 'BIN2DEC', 'BIN2HEX', 'BIN2OCT', 'HEX2BIN', 'HEX2DEC', 'HEX2OCT', 'OCT2BIN', 'OCT2DEC', 'OCT2HEX'],
  arg: 0,
  maxLength: 64,
  reason: 'linear in the digit count'
}, {
  names: ['BITLSHIFT', 'BITRSHIFT'],
  arg: 1,
  max: 53,
  reason: 'shift amount'
}];
var capsByName = {};
FUNCTION_ARG_CAPS.forEach(function (rule) {
  return rule.names.forEach(function (name) {
    capsByName[name] = rule;
  });
});
var flattenArg = function flattenArg(value) {
  return Array.isArray(value) ? value.flat(Infinity) : null;
};

/**
 * Throws when an array argument, or all of them together, would do more work than the caps allow.
 * Runs first in the callFunction hook, before anything walks the arrays.
 */
var guardArraySizes = function guardArraySizes(name) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var longest = 0;
  var arrayCount = 0;
  params.forEach(function (param) {
    var flat = flattenArg(param);
    if (!flat) return;
    if (flat.length > LIMITS.rangeCells) throw new Error("".concat(name, ": array argument too large"));
    arrayCount += 1;
    if (flat.length > longest) longest = flat.length;
  });
  if (arrayCount > 0 && longest * arrayCount > LIMITS.totalWork) throw new Error("".concat(name, ": combined work too large"));
};

/**
 * formulajs utils.parseNumber, which every capped built-in applies to its argument. Copied rather
 * than approximated: a cap that reads a value differently from the function lets through a shape
 * the function accepts. That is how =WORKDAY(45000,A1:A1) got past the cap: formulajs reads the
 * one-cell range [[40000]] as 40000 (isNaN and parseFloat both stringify it), the old check did not.
 */
var formulajsNumber = function formulajsNumber(value) {
  if (value === undefined || value === '') return NaN;
  // eslint-disable-next-line no-restricted-globals
  return isNaN(value) ? NaN : parseFloat(value);
};
var DAY_MS = 86400000;
var D1900 = Date.UTC(1900, 0, 1);

/**
 * formulajs utils.parseDate, for the same reason, including its serial-day 60 quirk. null where
 * formulajs would return an error, since the built-in then rejects the value itself.
 */
var formulajsDate = function formulajsDate(value) {
  // eslint-disable-next-line no-restricted-globals
  if (!isNaN(value)) {
    if (value instanceof Date) return value;
    var day = parseInt(value, 10);
    if (Number.isNaN(day) || day < 0) return null;
    return new Date(D1900 + (day - (day <= 60 ? 1 : 2)) * DAY_MS);
  }
  if (typeof value === 'string') {
    var parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }
  return null;
};

/**
 * Every value one argument can hand the built-in, unwrapped. A one-cell range is one value, so it
 * is capped like the scalar formulajs reads it as. A wider range is checked element by element: no
 * element over the cap reaches the function, whatever the function then does with the array.
 */
var scalarCandidates = function scalarCandidates(value) {
  var unwrap = function unwrap(item) {
    return item instanceof AmbiguousText ? item.text : item;
  };
  return Array.isArray(value) ? value.flat(Infinity).map(unwrap) : [unwrap(value)];
};

/**
 * The 6864c2b scalar checks, verbatim. Kept rather than replaced so the new guard can only ever
 * reject more: guardScalarCaps runs these first, then the checks below that read values the way
 * formulajs does.
 */
var guardScalarCapsAsBefore = function guardScalarCapsAsBefore(name, params, rule) {
  if (rule.sumOfArgs) {
    var total = params.reduce(function (sum, param) {
      return sum + (flattenArg(param) || [param]).reduce(function (s, v) {
        return s + (toNumberArg(v) || 0);
      }, 0);
    }, 0);
    if (total > rule.max) throw new Error("".concat(name, ": argument over cap"));
    return;
  }
  if (rule.daySpan) {
    var start = toDateArg(params[rule.daySpan[0]]);
    var end = toDateArg(params[rule.daySpan[1]]);
    if (start && end && Math.abs(end.getTime() - start.getTime()) / 86400000 > rule.max) throw new Error("".concat(name, ": date span over cap"));
    return;
  }
  var value = params[rule.arg];
  if (rule.maxLength !== undefined) {
    //For an array this counts elements, which is SERIESSUM's coefficient cap: keep it that way
    var length = Array.isArray(value) ? value.flat(Infinity).length : String(value === undefined || value === null ? '' : value).length;
    if (length > rule.maxLength) throw new Error("".concat(name, ": argument over cap"));
    return;
  }
  var number = toNumberArg(value);
  if (!Number.isNaN(number) && Math.abs(number) > rule.max) throw new Error("".concat(name, ": argument over cap"));
};

/**
 * Throws when a scalar argument is over its cap. Runs in the callFunction hook after
 * resolveAmbiguousArgs, so it reads the values the built-in is about to receive.
 */
var guardScalarCaps = function guardScalarCaps(name) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var rule = capsByName[name];
  if (!rule) return;
  guardScalarCapsAsBefore(name, params, rule);
  if (rule.sumOfArgs) {
    var total = params.flatMap(scalarCandidates).reduce(function (sum, v) {
      return sum + (formulajsNumber(v) || 0);
    }, 0);
    if (total > rule.max) throw new Error("".concat(name, ": argument over cap"));
    return;
  }
  if (rule.daySpan) {
    //min and max, not every pair: a range of 10,000 dates must not cost 10^8 comparisons
    var times = function times(index) {
      return scalarCandidates(params[index]).map(formulajsDate).filter(Boolean).map(function (date) {
        return date.getTime();
      });
    };
    var starts = times(rule.daySpan[0]);
    var ends = times(rule.daySpan[1]);
    if (starts.length && ends.length) {
      var widest = Math.max(Math.max.apply(Math, (0, _toConsumableArray2["default"])(ends)) - Math.min.apply(Math, (0, _toConsumableArray2["default"])(starts)), Math.max.apply(Math, (0, _toConsumableArray2["default"])(starts)) - Math.min.apply(Math, (0, _toConsumableArray2["default"])(ends)));
      if (widest / DAY_MS > rule.max) throw new Error("".concat(name, ": date span over cap"));
    }
    return;
  }
  var candidates = scalarCandidates(params[rule.arg]);
  if (rule.maxLength !== undefined) {
    //Also the length of each value: ARABIC(A1:A1) is one long string, not one element
    if (candidates.some(function (v) {
      return String(v === undefined || v === null ? '' : v).length > rule.maxLength;
    })) throw new Error("".concat(name, ": argument over cap"));
    return;
  }

  //Math.abs(NaN) > max is false: a value formulajs cannot read as a number is left for it to reject
  if (candidates.some(function (v) {
    return Math.abs(formulajsNumber(v)) > rule.max;
  })) throw new Error("".concat(name, ": argument over cap"));
};

/**
 * Throws when a call would do more work than the caps allow. Public, and the same checks the
 * callFunction hook runs (there, text arguments are unwrapped in between the two halves).
 */
var guardFunctionArgs = exports.guardFunctionArgs = function guardFunctionArgs(name) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  guardArraySizes(name, params);
  guardScalarCaps(name, params);
};

// ---------------------------------------------------------------------------
// Parser and result normalisation
// ---------------------------------------------------------------------------

/**
 * A formula parser with the table's value rules installed. Every call to a function goes through
 * the same eight steps, in this order:
 *
 *   1. yy.callFunction wrapper: push a call frame recording which arguments hold a tag, before
 *      anything touches them
 *   2. hook: guardArraySizes
 *   3. hook: resolveAmbiguousArgs (judges and unwraps tags leaf by leaf)
 *   4. hook: guardScalarCaps (reads the values the built-in is about to receive)
 *   5. hook: a tagged SUBSTITUTE, REGEXREPLACE or REPLACE is evaluated by its instrumented copy
 *      and handed back through done(), so formulajs skips its own run
 *   6. otherwise formulajs runs the built-in, once
 *   7. wrapper: re-tag the result if a tagged argument's characters reached it (only arguments
 *      the function reads count); REFERENCE and UNIQUE put back the tags and empty cells of the
 *      part of their argument they hand back
 *   8. wrapper: pop the frame, in finally
 *
 * yy belongs to the inner grammar parser and is an internal of hot-formula-parser, not a
 * published API. If an upgrade changes its shape each wrap is skipped rather than throwing, so
 * formulas keep working; the canary tests are what make that visible instead of silent.
 */
var createParser = function createParser() {
  var parser = new _hotFormulaParser.Parser();
  var callFrames = [];
  //Read by the tests only, to prove every frame is popped
  parser.jfCallFrames = callFrames;

  // Custom functions receive their arguments as one array. CONCAT is an alias of CONCATENATE.
  //CONCAT reads every argument as text, so a multiSelect collapses to its displayed string.
  //It cannot rely on resolveAmbiguousArgs for that: _callFunction runs a setFunction custom
  //function BEFORE it emits 'callFunction', so the hook has not run yet, and flat(Infinity)
  //would splice the selections in individually and give "1|12" instead of "1|1, 2".
  parser.setFunction('CONCAT', function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return collapseMultiValues(params).flat(Infinity).map(function (param) {
      if (param === null || param === undefined) return '';
      //It runs before the hook, so a cell's date is converted here: the epoch it joined as before
      return isCellDate(param) ? param.getTime() : param;
    }).join('');
  });
  var yy = parser.parser && parser.parser.yy;
  if (yy && typeof yy.callFunction === 'function') {
    var callFunction = yy.callFunction;
    yy.callFunction = function (name, params) {
      //A zero-argument call such as =PI() arrives with params undefined. _callFunction defaults it
      //to [] itself, so passing [] on is the same call, and every step below sees an array.
      var args = params || [];
      var frame = {
        name: String(name).toUpperCase(),
        tagged: args.map(hasTagLeaf),
        provenance: null,
        //The arguments as they arrived. The hook replaces entries of args, never the arrays
        //inside them, so this still holds every tag and empty cell after the built-in has run.
        original: args.some(hasMarker) ? args.slice() : null
      };
      callFrames.push(frame);
      try {
        var result = callFunction(name, args);
        //formulajs ranks a number missing from the list as 0, where a spreadsheet says #N/A. When an
        //empty cell took part (the target, or a gap in the list) that 0 would be new, so it is an
        //error here; without one, 0 is what it always was.
        if (RANK_FUNCTIONS.has(frame.name) && result === 0 && frame.original && (frame.original[0] === BLANK || hasBlank(frame.original[1]))) {
          throw new Error('#N/A');
        }
        return applyProvenance(frame, args, result);
      } finally {
        callFrames.pop();
      }
    };
  }

  /**
   * The grammar evaluates operators through yy.evaluateByOperator, not the callFunction hook,
   * so this is the only place a wrapper can be unwrapped before a comparison reaches ===.
   * Without it IF(text="Open",1,0) is always false, because an object is never === a string,
   * while > and < keep working because they coerce through valueOf(). & joins its operands, so
   * a tagged operand's text is in the result, which stays tagged: (A&"")+1 must not read 10Sai.
   */
  if (yy && typeof yy.evaluateByOperator === 'function') {
    var evaluateByOperator = yy.evaluateByOperator;
    yy.evaluateByOperator = function (name, params) {
      var tagged = name === '&' && Array.isArray(params) && params.some(hasTagLeaf);
      var operands = params;
      if (Array.isArray(params)) {
        //Comparing and joining read an empty cell as '' (as before); arithmetic reads it as 0
        operands = VALUE_OPERATORS.has(name) ? params.map(unwrapOperand) : params.map(function (param) {
          if (param === BLANK) return 0;
          return isCellDate(param) ? param.getTime() : param;
        });
      }
      var result = evaluateByOperator(name, operands);
      return tagged ? retagAmbiguous(result) : result;
    };
  }

  //Unary minus and plus call these, then turn NaN into 0, so -A on "10Sai" showed 0 and
  //-LEFT(A,5) showed -10. A tag is text that must not pose as a number, whichever sign it has.
  ['invertNumber', 'toNumber'].forEach(function (key) {
    if (!yy || typeof yy[key] !== 'function') return;
    var original = yy[key];
    yy[key] = function (value) {
      if (value instanceof AmbiguousText) throw new Error('#VALUE!');
      if (value === BLANK) return original(0);
      if (isCellDate(value)) return original(value.getTime());
      return original(value);
    };
  });
  parser.on('callFunction', function (name, params, done) {
    var upperName = String(name).toUpperCase();
    var frame = callFrames[callFrames.length - 1];
    guardArraySizes(upperName, params);
    resolveAmbiguousArgs(upperName, params);
    guardScalarCaps(upperName, params);

    //One evaluation, not two: when the instrumented copy answers, formulajs skips the built-in,
    //so a regex here runs exactly once, as it did before this hook existed.
    var instrumented = INSTRUMENTED_FUNCTIONS[upperName];
    if (instrumented && frame && frame.name === upperName && frame.tagged.some(Boolean)) {
      var outcome = instrumented(params);
      if (outcome) {
        frame.provenance = outcome.contributes;
        done(outcome.result);
      } else {
        //formulajs runs the built-in on a shape the copy does not cover. Its result can only be
        //an error or a non-string there (see INSTRUMENTED_FUNCTIONS), but if it is text it is
        //treated as coming from every argument: strict, never a silent pass.
        frame.provenance = UNKNOWN_PROVENANCE;
      }
    }
  });
  return parser;
};

/**
 * Turn the parser's result into the string a cell displays.
 */
var normaliseResult = exports.normaliseResult = function normaliseResult(result) {
  //A formula that is only a reference, `=B`, hands the wrapper straight back
  if (result instanceof AmbiguousText) result = result.text;
  //An empty cell displays as it always did
  if (result === BLANK) return '';
  if (result instanceof Date) return String(result.getTime());
  if (typeof result === 'number') {
    //Round first, then test: a finite value near Number.MAX_VALUE (FACT(170)) overflows to Infinity
    //when multiplied by 100, and would otherwise display as the literal string "Infinity"
    var rounded = Math.round(result * 100) / 100;
    return Number.isFinite(rounded) ? String(rounded) : FORMULA_ERROR;
  }

  // The legacy engine rounds a boolean like a number, so TRUE displays as 1 there. Same here.
  if (typeof result === 'boolean') return result ? '1' : '0';
  if (result === null || result === undefined) return '';
  if (Array.isArray(result)) {
    var joined = result.flat(Infinity).map(function (item) {
      return normaliseResult(item);
    }).join(', ');
    return joined.length > LIMITS.resultLength ? FORMULA_ERROR : joined;
  }
  var text = String(result);
  return text.length > LIMITS.resultLength ? FORMULA_ERROR : text;
};

/**
 * Text a formula cannot read as a number without guessing, such as "10Sai" or "0x10".
 *
 * Kept as an object rather than a string so the parser's toNumber() returns undefined for it
 * and add.js / divide.js throw #VALUE!, instead of quietly using a truncated prefix.
 */
var AmbiguousText = /*#__PURE__*/function () {
  /**
   * derived is false for a tag straight from a cell, range or multiSelect, and true for one that
   * came out of a function or operator. Before tags followed values through functions, derived
   * text reached its consumer as a plain string, so every text-reading position keeps accepting
   * it exactly as it did: only numeric positions reject it, which is the fix.
   */
  function AmbiguousText(text) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$derived = _ref.derived,
      derived = _ref$derived === void 0 ? false : _ref$derived;
    (0, _classCallCheck2["default"])(this, AmbiguousText);
    this.text = text;
    this.derived = derived;
  }
  (0, _createClass2["default"])(AmbiguousText, [{
    key: "toString",
    value: function toString() {
      return this.text;
    }
  }, {
    key: "valueOf",
    value: function valueOf() {
      return this.text;
    }
  }]);
  return AmbiguousText;
}();
/**
 * The selected values of a multiSelect cell holding more than one selection. An Array subclass
 * so the parser and formulajs treat it as a range and SUM adds every selection, while toString
 * keeps the display form for anything that reads it as text.
 */
var MultiValue = /*#__PURE__*/function (_Array) {
  (0, _inherits2["default"])(MultiValue, _Array);
  var _super = _createSuper(MultiValue);
  function MultiValue() {
    (0, _classCallCheck2["default"])(this, MultiValue);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(MultiValue, [{
    key: "toString",
    value: function toString() {
      return this.join(', ');
    }
  }]);
  return MultiValue;
}( /*#__PURE__*/(0, _wrapNativeSuper2["default"])(Array));
/**
 * An empty cell: a blank text, dropdown or multiSelect cell, or a cell outside the table. Before,
 * a formula received '' for one. It is read the way spreadsheets read an empty cell, wherever
 * that does not change a result that works: skipped by list functions (BLANK_SKIPPING_ARGS), 0 in
 * arithmetic and in a single number argument, '' wherever text is read. toString and valueOf give
 * '', so any path no hook reaches sees exactly the '' it saw before.
 */
var Blank = /*#__PURE__*/function () {
  function Blank() {
    (0, _classCallCheck2["default"])(this, Blank);
  }
  (0, _createClass2["default"])(Blank, [{
    key: "toString",
    value:
    // eslint-disable-next-line class-methods-use-this
    function toString() {
      return '';
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "valueOf",
    value: function valueOf() {
      return '';
    }
  }]);
  return Blank;
}();
var BLANK = new Blank();

/**
 * A valid date a column or row-path formula returned, cached as a date rather than as its display
 * string, so =YEAR(A) reads 2024 where A is =DATE(2024,1,15). Only the date-reading arguments of
 * CELL_DATE_ARGS receive it as a date; every other reader gets getTime(), the epoch number it read
 * before. A DATE() written inside a formula is a plain Date and behaves exactly as before.
 */
var CellDate = /*#__PURE__*/function (_Date) {
  (0, _inherits2["default"])(CellDate, _Date);
  var _super2 = _createSuper(CellDate);
  function CellDate() {
    (0, _classCallCheck2["default"])(this, CellDate);
    return _super2.apply(this, arguments);
  }
  return (0, _createClass2["default"])(CellDate);
}( /*#__PURE__*/(0, _wrapNativeSuper2["default"])(Date));
var isCellDate = function isCellDate(value) {
  return value instanceof CellDate;
};

/** A cell asked for while it is being evaluated: a loop, in either engine. */
var CycleError = /*#__PURE__*/function (_Error) {
  (0, _inherits2["default"])(CycleError, _Error);
  var _super3 = _createSuper(CycleError);
  function CycleError() {
    (0, _classCallCheck2["default"])(this, CycleError);
    return _super3.call(this, 'cycle');
  }
  return (0, _createClass2["default"])(CycleError);
}( /*#__PURE__*/(0, _wrapNativeSuper2["default"])(Error));
/**
 * A walk about to go deeper than LIMITS.depth column or row-path cells. Not a failure:
 * resolveRoot resolves the deeper cell first and retries the walk.
 */
var DepthExceeded = /*#__PURE__*/function (_Error2) {
  (0, _inherits2["default"])(DepthExceeded, _Error2);
  var _super4 = _createSuper(DepthExceeded);
  function DepthExceeded() {
    (0, _classCallCheck2["default"])(this, DepthExceeded);
    return _super4.call(this, 'reference depth exceeded');
  }
  return (0, _createClass2["default"])(DepthExceeded);
}( /*#__PURE__*/(0, _wrapNativeSuper2["default"])(Error));
/** resolveRoot went past the number of steps that always suffices. Reported as Error. */
var ConvergenceError = /*#__PURE__*/function (_Error3) {
  (0, _inherits2["default"])(ConvergenceError, _Error3);
  var _super5 = _createSuper(ConvergenceError);
  function ConvergenceError() {
    (0, _classCallCheck2["default"])(this, ConvergenceError);
    return _super5.call(this, 'resolution did not converge');
  }
  return (0, _createClass2["default"])(ConvergenceError);
}( /*#__PURE__*/(0, _wrapNativeSuper2["default"])(Error));
/**
 * For each overlay resolveColumnFormulaCells returns, the cells that show their own typed text
 * because their row-path formula failed ("rowIndex:columnId"). That text is the stored cell value,
 * not a result, so pass 3 reads it exactly as it always did. Kept beside the overlay, not in it, so
 * the overlay's shape is unchanged.
 */
var typedTextFallbacks = new WeakMap();

//Test hooks: a fault-injection override of resolveRoot's bound, and the state of the last resolve
var convergenceBoundOverride = null;
var lastResolverState = null;

/**
 * The number a text value represents, or NaN when it does not represent one.
 *
 * Number() is the only judge here. The regex this replaced was narrower than Number(), so
 * formats such as "1e3" and ".5" reached the parser as strings and were prefix-coerced there:
 * parseInt("1e3", 10) is 1, which made =A+B with A=2 return 3.
 */
var numericValue = function numericValue(text) {
  if (text === '' || RADIX_LITERAL_REGEXP.test(text)) return NaN;
  var numeric = Number(text);
  return Number.isFinite(numeric) ? numeric : NaN;
};

/**
 * True for text Number() rejects but parseFloat/parseInt would silently truncate to a number.
 * That set is exactly the bug: "10Sai" became 10, "2024-01-05" became 2024.
 *
 * Pure text such as "Sai" is deliberately not included. parseFloat already returns NaN for it,
 * so it is ignored by SUM and gives #VALUE! from +, which is correct and stays unchanged.
 */
var isAmbiguousText = exports.isAmbiguousText = function isAmbiguousText(value) {
  if (typeof value !== 'string') return false;
  var text = value.trim();
  //Any non-blank text Number() rejects. Both halves of the defect are one mistake: "10Sai"
  //silently became 10, "Sai prasad 10" silently became nothing, because formulajs skips a
  //string it cannot parse. A formula must not produce a number from either.
  return text !== '' && Number.isNaN(numericValue(text));
};

/**
 * "15" from a text column, or from another formula's result, must behave as 15 inside a formula:
 * the parser compares strings as text and AVERAGE rejects them outright.
 */
var asScopeNumber = function asScopeNumber(value) {
  if (typeof value !== 'string') return value;
  var numeric = numericValue(value.trim());
  if (!Number.isNaN(numeric)) return numeric;
  return isAmbiguousText(value) ? new AmbiguousText(value) : value;
};
var ANY_ARG = exports.ANY_ARG = 'any';

/**
 * Functions that may receive an ambiguous text value, and which of their arguments read it as
 * text. Position matters: LEFT(B,2) must work while LEFT("abcdef",B) must fail. Three shapes:
 *
 *   ANY_ARG             every argument reads text
 *   { exceptArgs: [0] } variadic; every argument reads text except these positions
 *   [0, 1]              fixed arity; only these positions read text
 *
 * A function absent from this table errors on any ambiguous argument, which covers SUM,
 * AVERAGE, ROUND, COUNT, MIN, MAX and the rest of the numeric set.
 *
 * Every key is in the parser's SUPPORTED_FORMULAS except CONCAT, which createParser registers
 * itself. IFERROR, IFNA, VLOOKUP, HLOOKUP, INDEX, TEXT, VALUE, ISERROR and TYPE are absent from
 * SUPPORTED_FORMULAS and already return #NAME?, so listing them would be dead entries.
 *
 * MATCH, SUMIF, SUMIFS, AVERAGEIF and AVERAGEIFS are already broken in formulajs 2.0.2, before
 * and after this change: MATCH throws a TypeError on any range containing a number, and SUMIF
 * ignores its sum range. Their positions are declared correctly so the policy holds if
 * formulajs is ever fixed.
 */
var TEXT_SAFE_ARGS = exports.TEXT_SAFE_ARGS = {
  CONCAT: ANY_ARG,
  CONCATENATE: ANY_ARG,
  IF: ANY_ARG,
  SWITCH: ANY_ARG,
  EXACT: ANY_ARG,
  COUNTA: ANY_ARG,
  COUNTBLANK: ANY_ARG,
  COUNTIF: ANY_ARG,
  COUNTIFS: ANY_ARG,
  //Logical: these read truthiness, never a number. The requirement covers numeric operations,
  //so AND("Sai") must keep returning what it returns today.
  AND: ANY_ARG,
  OR: ANY_ARG,
  NOT: ANY_ARG,
  XOR: ANY_ARG,
  //Array and pass-through helpers: they restructure values, they never coerce one to a number.
  ARGS2ARRAY: ANY_ARG,
  FLATTEN: ANY_ARG,
  TRANSPOSE: ANY_ARG,
  UNIQUE: ANY_ARG,
  JOIN: ANY_ARG,
  REFERENCE: ANY_ARG,
  NUMBERS: ANY_ARG,
  COUNTUNIQUE: ANY_ARG,
  //Zero-arity: the argument is never read, so wrapping it must not change the answer.
  PI: ANY_ARG,
  E: ANY_ARG,
  TRUE: ANY_ARG,
  FALSE: ANY_ARG,
  NOW: ANY_ARG,
  TODAY: ANY_ARG,
  RAND: ANY_ARG,
  HTML2TEXT: [0],
  // a text function
  ISBINARY: [0],
  // an information predicate, like ISTEXT

  CHOOSE: {
    exceptArgs: [0]
  },
  // arg 1 is the index; the choices may be text
  SUMIFS: {
    exceptArgs: [0]
  },
  // arg 1 is the sum range; the criteria may be text
  AVERAGEIFS: {
    exceptArgs: [0]
  },
  T: [0],
  TRIM: [0],
  UPPER: [0],
  LOWER: [0],
  PROPER: [0],
  CLEAN: [0],
  LEN: [0],
  CODE: [0],
  UNICODE: [0],
  REPT: [0],
  LEFT: [0],
  RIGHT: [0],
  MID: [0],
  ISBLANK: [0],
  ISTEXT: [0],
  ISNONTEXT: [0],
  ISNUMBER: [0],
  ISLOGICAL: [0],
  FIND: [0, 1],
  SEARCH: [0, 1],
  SPLIT: [0, 1],
  MATCH: [0, 1],
  SUMIF: [0, 1],
  AVERAGEIF: [0, 1],
  SUBSTITUTE: [0, 1, 2],
  REPLACE: [0, 3]
};
var readsText = function readsText(allowed, index) {
  if (allowed === undefined) return false;
  if (allowed === ANY_ARG) return true;
  if (Array.isArray(allowed)) return allowed.includes(index);
  return !allowed.exceptArgs.includes(index);
};

//Text a date function may parse. new Date() alone is too lenient to trust with cell text: it reads
//"Sai 10" as October 2001. Only digits, separators, month and weekday names, AM/PM and zone letters.
var DATE_WORDS = /\b(jan(uary)?|feb(ruary)?|mar(ch)?|apr(il)?|may|june?|july?|aug(ust)?|sep(t(ember)?)?|oct(ober)?|nov(ember)?|dec(ember)?|mon(day)?|tue(s(day)?)?|wed(nesday)?|thu(r(s(day)?)?)?|fri(day)?|sat(urday)?|sun(day)?|am|pm|utc|gmt)\b/gi;
var isDateText = exports.isDateText = function isDateText(text) {
  return /\d/.test(text) && /^[\d\s\-/:.,+TZ]*$/i.test(String(text).replace(DATE_WORDS, ' '));
};
var isRomanText = function isRomanText(text) {
  return /^-?[MDCLXVI]+$/i.test(String(text).trim());
};
var isBaseDigits = function isBaseDigits(text) {
  return /^-?[0-9A-Z]+$/i.test(String(text).trim());
};
//A complex number as formulajs writes one: 3, 3+4i, 4i, -i, 1e2-3j. IMSUM and IMPRODUCT hand a lone
//argument back unchecked, so without this "Sai prasad 10" came straight back out of them.
var COMPLEX_NUMBER = '(\\d+\\.?\\d*|\\.\\d+)(e[-+]?\\d+)?';
var COMPLEX_TEXT_REGEXP = new RegExp("^[-+]?(".concat(COMPLEX_NUMBER, "([-+](").concat(COMPLEX_NUMBER, ")?[ij])?|(").concat(COMPLEX_NUMBER, ")?[ij])$"), 'i');
var isComplexText = function isComplexText(text) {
  return COMPLEX_TEXT_REGEXP.test(String(text).trim());
};
var isImaginaryUnit = function isImaginaryUnit(text) {
  return /^[ij]$/.test(String(text).trim());
};

/**
 * Positions this change newly opens to text taken straight from a cell: functions whose job is to
 * parse text (a date, a Roman numeral, digits in another base, a complex number, a unit name), and
 * which rejected every non-numeric cell value before. Each position was checked against the
 * formulajs source and has a reference-vs-literal parity test.
 *
 * A direct value here must also pass `accepts` and LIMITS.textArgLength. A derived value (one a
 * nested function produced) is not held to either: it reached these positions as a plain string
 * before, unchecked, and still does. So =COUNTIN(REPT(A,300),"a") keeps giving 300.
 */
var DIRECT_TEXT_ARGS = exports.DIRECT_TEXT_ARGS = {
  DATEVALUE: {
    args: [0],
    accepts: isDateText
  },
  TIMEVALUE: {
    args: [0],
    accepts: isDateText
  },
  YEAR: {
    args: [0],
    accepts: isDateText
  },
  MONTH: {
    args: [0],
    accepts: isDateText
  },
  DAY: {
    args: [0],
    accepts: isDateText
  },
  HOUR: {
    args: [0],
    accepts: isDateText
  },
  MINUTE: {
    args: [0],
    accepts: isDateText
  },
  SECOND: {
    args: [0],
    accepts: isDateText
  },
  WEEKDAY: {
    args: [0],
    accepts: isDateText
  },
  WEEKNUM: {
    args: [0],
    accepts: isDateText
  },
  ISOWEEKNUM: {
    args: [0],
    accepts: isDateText
  },
  EDATE: {
    args: [0],
    accepts: isDateText
  },
  EOMONTH: {
    args: [0],
    accepts: isDateText
  },
  DAYS: {
    args: [0, 1],
    accepts: isDateText
  },
  DAYS360: {
    args: [0, 1],
    accepts: isDateText
  },
  YEARFRAC: {
    args: [0, 1],
    accepts: isDateText
  },
  NETWORKDAYS: {
    args: [0, 1, 2],
    accepts: isDateText
  },
  WORKDAY: {
    args: [0, 2],
    accepts: isDateText
  },
  TBILLEQ: {
    args: [0, 1],
    accepts: isDateText
  },
  TBILLPRICE: {
    args: [0, 1],
    accepts: isDateText
  },
  TBILLYIELD: {
    args: [0, 1],
    accepts: isDateText
  },
  ARABIC: {
    args: [0],
    accepts: isRomanText
  },
  DECIMAL: {
    args: [0],
    accepts: isBaseDigits
  },
  BIN2DEC: {
    args: [0],
    accepts: isBaseDigits
  },
  BIN2HEX: {
    args: [0],
    accepts: isBaseDigits
  },
  BIN2OCT: {
    args: [0],
    accepts: isBaseDigits
  },
  HEX2BIN: {
    args: [0],
    accepts: isBaseDigits
  },
  HEX2DEC: {
    args: [0],
    accepts: isBaseDigits
  },
  HEX2OCT: {
    args: [0],
    accepts: isBaseDigits
  },
  OCT2BIN: {
    args: [0],
    accepts: isBaseDigits
  },
  OCT2DEC: {
    args: [0],
    accepts: isBaseDigits
  },
  OCT2HEX: {
    args: [0],
    accepts: isBaseDigits
  },
  //Complex numbers
  IMABS: {
    args: [0],
    accepts: isComplexText
  },
  IMAGINARY: {
    args: [0],
    accepts: isComplexText
  },
  IMARGUMENT: {
    args: [0],
    accepts: isComplexText
  },
  IMCONJUGATE: {
    args: [0],
    accepts: isComplexText
  },
  IMCOS: {
    args: [0],
    accepts: isComplexText
  },
  IMCOSH: {
    args: [0],
    accepts: isComplexText
  },
  IMCOT: {
    args: [0],
    accepts: isComplexText
  },
  IMCSC: {
    args: [0],
    accepts: isComplexText
  },
  IMCSCH: {
    args: [0],
    accepts: isComplexText
  },
  IMEXP: {
    args: [0],
    accepts: isComplexText
  },
  IMLN: {
    args: [0],
    accepts: isComplexText
  },
  IMLOG10: {
    args: [0],
    accepts: isComplexText
  },
  IMLOG2: {
    args: [0],
    accepts: isComplexText
  },
  IMREAL: {
    args: [0],
    accepts: isComplexText
  },
  IMSEC: {
    args: [0],
    accepts: isComplexText
  },
  IMSECH: {
    args: [0],
    accepts: isComplexText
  },
  IMSIN: {
    args: [0],
    accepts: isComplexText
  },
  IMSINH: {
    args: [0],
    accepts: isComplexText
  },
  IMSQRT: {
    args: [0],
    accepts: isComplexText
  },
  IMTAN: {
    args: [0],
    accepts: isComplexText
  },
  IMPOWER: {
    args: [0],
    accepts: isComplexText
  },
  IMDIV: {
    args: [0, 1],
    accepts: isComplexText
  },
  IMSUB: {
    args: [0, 1],
    accepts: isComplexText
  },
  IMSUM: {
    args: ANY_ARG,
    accepts: isComplexText
  },
  IMPRODUCT: {
    args: ANY_ARG,
    accepts: isComplexText
  },
  COMPLEX: {
    args: [2],
    accepts: isImaginaryUnit
  },
  CONVERT: {
    args: [1, 2]
  },
  // unit names
  COUNTIN: {
    args: ANY_ARG
  } // counts matches, never reads a number
};

/**
 * Positions that accept only derived text, never a cell value directly. The regex functions build
 * a RegExp from their arguments, and a cell's text reaching one directly is refused, as it always
 * was. Text built by a nested function reached them as a plain string before and still does.
 */
var DERIVED_TEXT_ARGS = exports.DERIVED_TEXT_ARGS = {
  REGEXEXTRACT: ANY_ARG,
  REGEXMATCH: ANY_ARG,
  REGEXREPLACE: ANY_ARG,
  //The comparison functions compare text as text (EQ(TRIM(A),"10Sai") is TRUE), exactly as the =
  //and <> operators do. Direct cell text was refused by them before and still is.
  EQ: ANY_ARG,
  NE: ANY_ARG,
  GTE: ANY_ARG,
  LT: ANY_ARG,
  LTE: ANY_ARG
};

/**
 * Arguments that read a list of numbers, where a spreadsheet skips an empty cell rather than read
 * it as 0: SUM(A,B) with A empty is B, PRODUCT(A,B) too, RANK.EQ ranks among the filled cells.
 * Before, these received '' there: most of them skipped it already (SUM, AVERAGE, COUNT, MIN,
 * MAX), the rest returned an error (PRODUCT, RANK.EQ, LARGE, SUMSQ). Absent on purpose, because
 * they read '' as 0 before and skipping would change a result that works: MEDIAN and the A
 * functions (AVERAGEA, MAXA, MINA, STDEVA, STDEVPA, VARA, VARPA). SUBTOTAL and AGGREGATE follow the
 * function their selector picks (selectedArgument).
 */
var BLANK_SKIPPING_ARGS = exports.BLANK_SKIPPING_ARGS = {
  SUM: ANY_ARG,
  PRODUCT: ANY_ARG,
  AVERAGE: ANY_ARG,
  COUNT: ANY_ARG,
  MAX: ANY_ARG,
  MIN: ANY_ARG,
  'MODE.MULT': ANY_ARG,
  'MODE.SNGL': ANY_ARG,
  'STDEV.P': ANY_ARG,
  'STDEV.S': ANY_ARG,
  STDEVP: ANY_ARG,
  'VAR.P': ANY_ARG,
  'VAR.S': ANY_ARG,
  VARP: ANY_ARG,
  GEOMEAN: ANY_ARG,
  HARMEAN: ANY_ARG,
  AVEDEV: ANY_ARG,
  DEVSQ: ANY_ARG,
  SUMSQ: ANY_ARG,
  KURT: ANY_ARG,
  SKEW: ANY_ARG,
  'SKEW.P': ANY_ARG,
  LARGE: [0],
  SMALL: [0],
  TRIMMEAN: [0],
  'QUARTILE.EXC': [0],
  'QUARTILE.INC': [0],
  'RANK.EQ': [1],
  'RANK.AVG': [1],
  //The parser's undotted aliases of the functions above
  MODEMULT: ANY_ARG,
  MODESNGL: ANY_ARG,
  SKEWP: ANY_ARG,
  RANKEQ: [1],
  RANKAVG: [1],
  QUARTILEEXC: [0],
  QUARTILEINC: [0],
  PERCENTILEEXC: [0],
  PERCENTILEINC: [0],
  PERCENTRANKEXC: [0],
  PERCENTRANKINC: [0],
  NPV: {
    exceptArgs: [0]
  } // argument 0 is the rate; the cash flows skip an empty cell
};

/**
 * The functions AGGREGATE and SUBTOTAL call, by selector (formula-parser.js AGGREGATE, SUBTOTAL).
 * AGGREGATE(function_num, options, ref1, ref2) passes ref1, and ref2 for 14 to 19; SUBTOTAL
 * (function_code, ref1) passes ref1, for 1 to 11 and 101 to 111. Every name is one the parser
 * supports, so the tables below apply to it (PERCENTILEINC, not PERCENTILE.INC).
 */
var AGGREGATE_FUNCTIONS = ['AVERAGE', 'COUNT', 'COUNTA', 'MAX', 'MIN', 'PRODUCT', 'STDEV.S', 'STDEV.P', 'SUM', 'VAR.S', 'VAR.P', 'MEDIAN', 'MODE.SNGL', 'LARGE', 'SMALL', 'PERCENTILEINC', 'QUARTILEINC', 'PERCENTILEEXC', 'QUARTILEEXC'];
var SUBTOTAL_FUNCTIONS = AGGREGATE_FUNCTIONS.slice(0, 11);

/**
 * The selected function and argument that AGGREGATE or SUBTOTAL argument `index` reaches, or null.
 * Read-only: it inspects the selector the hook has already settled (arguments are handled left to
 * right), reads it as formulajs does, and changes nothing. An unknown selector, or an argument the
 * selected function never receives, is null: it keeps today's ''.
 */
var selectedArgument = function selectedArgument(name, index, params) {
  if (name !== 'AGGREGATE' && name !== 'SUBTOTAL') return null;
  var selector = formulajsNumber(params[0]);
  if (!Number.isInteger(selector)) return null;
  if (name === 'AGGREGATE') {
    var _selected = AGGREGATE_FUNCTIONS[selector - 1];
    if (!_selected) return null;
    if (index === 2) return {
      name: _selected,
      index: 0
    };
    if (index === 3 && selector >= 14) return {
      name: _selected,
      index: 1
    };
    return null;
  }
  var code = selector > 100 ? selector - 100 : selector;
  var selected = selector >= 1 && selector <= 111 ? SUBTOTAL_FUNCTIONS[code - 1] : undefined;
  if (!selected || selector > 11 && selector < 101) return null;
  return index === 1 ? {
    name: selected,
    index: 0
  } : null;
};

/**
 * Number positions where an empty cell keeps reaching the function as '', as before, because
 * reading it as 0 would give a value a spreadsheet does not give there. Filled from the review of
 * every position where an empty cell turned an error into a value.
 */
var BLANK_STAYS_EMPTY = exports.BLANK_STAYS_EMPTY = {
  //'' gave a value before, and 0 gives a different one: STDEVS('',2,2) is 0, STDEVS(0,2,2) is 1.15
  STDEVS: ANY_ARG,
  VARS: ANY_ARG,
  //COMPLEX(2,'',2) is 2, COMPLEX(2,0,2) is an error
  COMPLEX: [0, 1],
  //LARGE(range,'') handed the range back; LARGE(range,0) is undefined
  LARGE: [1],
  SMALL: [1],
  //0 is outside what the argument accepts, so a spreadsheet reports an error, while formulajs
  //returns a fallback or a meaningless number: CHAR(0) is "", NORM.S.INV(0) is -141.42,
  //SUBTOTAL(0) counts, WEEKDAY(d,0) uses type 1, COLUMN(range,0) is the range
  AGGREGATE: [0],
  SUBTOTAL: [0],
  CHAR: [0],
  UNICHAR: [0],
  COLUMN: [1],
  ROW: [1],
  WEEKDAY: [1],
  FLOOR: [1],
  // significance 0
  LOG: [1],
  // base 0
  RATE: [0],
  // no periods
  'BETA.INV': [0, 1, 2],
  BETAINV: [0, 1, 2],
  'CHISQ.DIST': [1],
  // no degrees of freedom
  'CHISQ.INV': [1],
  CONFIDENCE: [0, 1],
  'CONFIDENCE.NORM': [0, 1],
  'EXPON.DIST': [1],
  // lambda 0
  EXPONDIST: [1],
  'LOGNORM.DIST': [0],
  LOGNORMDIST: [0],
  'LOGNORM.INV': [0, 2],
  LOGNORMINV: [0, 2],
  'NORM.INV': [0, 2],
  // probability 0, standard deviation 0
  NORMINV: [0, 2],
  'NORM.S.INV': [0],
  NORMSINV: [0],
  PERCENTRANKEXC: [1],
  // a value outside the list
  PERCENTRANKINC: [1],
  'WEIBULL.DIST': [1],
  // alpha 0
  WEIBULLDIST: [1]
};

//How an empty cell reaches argument `index` of `name`
var BLANK_AS_TEXT = 'text'; // '' (every text position)
var BLANK_SKIPPED = 'skip'; // left out of the list
var BLANK_AS_ZERO = 'zero'; // 0, as a scalar and inside an array (SUMPRODUCT)
var BLANK_SCALAR_ZERO = 'scalar-zero'; // 0 as a single number argument; '' inside an array, as before

var blankPolicy = function blankPolicy(name, index, policy, params) {
  //AGGREGATE and SUBTOTAL hand a reference to the function their selector picks: an empty cell there
  //is read as that function reads one, by that function's own position policy (COUNTA reads text)
  var selected = selectedArgument(name, index, params);
  if (selected) {
    var selectedPolicy = positionPolicy(selected.name, selected.index);
    return blankPolicy(selected.name, selected.index, selectedPolicy, params);
  }
  if ((name === 'AGGREGATE' || name === 'SUBTOTAL') && index > 0) {
    //An unknown selector, or an argument the selected function never receives: '' as before
    if (!(name === 'AGGREGATE' && index === 1)) return BLANK_AS_TEXT;
  }
  if (policy.readsText || readsText(BLANK_STAYS_EMPTY[name], index)) return BLANK_AS_TEXT;
  if (readsText(BLANK_SKIPPING_ARGS[name], index)) return BLANK_SKIPPED;
  if (name === 'SUMPRODUCT') return BLANK_AS_ZERO;
  return BLANK_SCALAR_ZERO;
};

//An argument with every empty cell replaced as `how` says. A copy; the input is untouched.
var settleBlanks = function settleBlanks(value, how) {
  if (value === BLANK) {
    if (how === BLANK_SKIPPED) return [];
    return how === BLANK_AS_TEXT ? '' : 0;
  }
  if (!hasMarker(value)) return value;
  if (Array.isArray(value)) {
    if (how === BLANK_SKIPPED) {
      return value.filter(function (item) {
        return item !== BLANK;
      }).map(function (item) {
        return settleBlanks(item, BLANK_SKIPPED);
      });
    }
    var inside = how === BLANK_AS_ZERO ? BLANK_AS_ZERO : BLANK_AS_TEXT;
    return mapArray(value, function (item) {
      return settleBlanks(item, inside);
    });
  }
  if (isPlainObject(value)) return mapObject(value, function (item) {
    return settleBlanks(item, BLANK_AS_TEXT);
  });
  return value;
};

/**
 * Arguments formulajs reads through utils.parseDate, where a date from a cell (CellDate) is passed
 * as a date. Taken from the bundle, and re-derived from it by a test: NETWORKDAYS and WORKDAY call
 * their .INTL versions, which parse the start, the end (NETWORKDAYS) and each holiday. DATEVALUE is
 * not one: it needs text, and a date there stays an error.
 */
var CELL_DATE_ARGS = exports.CELL_DATE_ARGS = {
  DAY: [0],
  HOUR: [0],
  MINUTE: [0],
  MONTH: [0],
  SECOND: [0],
  YEAR: [0],
  WEEKDAY: [0],
  WEEKNUM: [0],
  ISOWEEKNUM: [0],
  EDATE: [0],
  EOMONTH: [0],
  TIMEVALUE: [0],
  DAYS: [0, 1],
  DAYS360: [0, 1],
  YEARFRAC: [0, 1],
  TBILLEQ: [0, 1],
  TBILLPRICE: [0, 1],
  TBILLYIELD: [0, 1],
  NETWORKDAYS: [0, 1, 2],
  WORKDAY: [0, 2]
};
var isCellDatePosition = function isCellDatePosition(name, index) {
  return readsText(CELL_DATE_ARGS[name], index);
};

//The date arguments formulajs reads as a list, parsing each element: the holidays
var CELL_DATE_LIST_ARGS = {
  NETWORKDAYS: [2],
  WORKDAY: [2]
};
var isCellDateListPosition = function isCellDateListPosition(name, index) {
  return readsText(CELL_DATE_LIST_ARGS[name], index);
};

/**
 * The one generic place a cell's date becomes the epoch number it was before: kept as a date where
 * preserveDate (a CELL_DATE_ARGS position), getTime() everywhere else, inside arrays, match metadata
 * and groups objects too. The unwrap, collapse, tag and blank helpers never touch a CellDate, so it
 * reaches this point intact whatever happened to the argument before.
 */
var coerceCellDates = function coerceCellDates(value, preserveDate) {
  var preserveInList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (isCellDate(value)) return preserveDate ? value : value.getTime();
  if (!hasMarker(value)) return value;
  //Inside an array a date stays a date only as a direct element of a list the function parses
  //element by element (holidays). A range's rows are arrays, which formulajs cannot parse as one
  //date, so the dates in them read as before, as do array elements everywhere else.
  return mapDeep(value, function (item) {
    return coerceCellDates(item, preserveInList && !Array.isArray(item), false);
  });
};
var NUMBER_POSITION = {
  readsText: false
};
var TEXT_POSITION = {
  readsText: true,
  directAllowed: true,
  newlyAdmitted: false,
  accepts: null
};
var DERIVED_ONLY_POSITION = {
  readsText: true,
  directAllowed: false,
  newlyAdmitted: false,
  accepts: null
};

/** What argument `index` of `name` does with a tag. */
var positionPolicy = function positionPolicy(name, index) {
  if (readsText(TEXT_SAFE_ARGS[name], index)) return TEXT_POSITION;
  var direct = DIRECT_TEXT_ARGS[name];
  if (direct && readsText(direct.args, index)) {
    return {
      readsText: true,
      directAllowed: true,
      newlyAdmitted: true,
      accepts: direct.accepts || null
    };
  }
  if (readsText(DERIVED_TEXT_ARGS[name], index)) return DERIVED_ONLY_POSITION;
  return NUMBER_POSITION;
};

/**
 * Whether the function may hand this argument back unchanged, so the hook must leave its tag on.
 * From the formulajs source: IF is `test ? then : otherwise`; CHOOSE returns arguments[index];
 * SWITCH returns arguments[2k + 2] or, when the count after the expression is odd, the default in
 * the last position (an odd index, so "odd index = match value" alone would unwrap it); ARGS2ARRAY
 * slices its arguments. FLATTEN, TRANSPOSE and UNIQUE pass an array argument's elements through,
 * but a string argument is split into characters (FLATTEN, TRANSPOSE) or compared with === (UNIQUE),
 * so only array arguments pass through for those three.
 */
var isPassThrough = function isPassThrough(name, index, argCount, param) {
  switch (name) {
    case 'IF':
      return index === 1 || index === 2;
    case 'CHOOSE':
      return index >= 1;
    case 'SWITCH':
      {
        if (index === 0) return false;
        var argc = argCount - 1;
        if (argc % 2 === 1 && index === argCount - 1) return true;
        return index % 2 === 0;
      }
    case 'ARGS2ARRAY':
      return true;
    case 'FLATTEN':
    case 'TRANSPOSE':
    case 'UNIQUE':
      return Array.isArray(param);
    default:
      return false;
  }
};

//Leaf helpers. A "leaf" is every tag inside a value, however deep: a scalar, a range (arrays of
//arrays), a nested array or a MultiValue. Only array ELEMENTS are leaves: they are the values a
//function consumes. A RegExp match's index, input and groups are metadata, carried by every copy
//(mapArray) and found by hasMarker, but never validated or counted as an input. None of these
//helpers mutates its input.
var forEachLeaf = function forEachLeaf(value, visit) {
  if (value instanceof AmbiguousText) visit(value);else if (Array.isArray(value)) value.forEach(function (item) {
    return forEachLeaf(item, visit);
  });
};
var hasTagLeaf = function hasTagLeaf(value) {
  var found = false;
  forEachLeaf(value, function () {
    found = true;
  });
  return found;
};
var hasOwn = function hasOwn(value, key) {
  return Object.prototype.hasOwnProperty.call(value, key);
};

//What String.prototype.match returns: an array with index, input and groups of its own
var isMatchArray = function isMatchArray(value) {
  return Array.isArray(value) && hasOwn(value, 'index') && hasOwn(value, 'input');
};

//A match's groups object, or one REFERENCE handed back. Nothing else a formula sees is a plain object.
var isPlainObject = function isPlainObject(value) {
  if (value === null || (0, _typeof2["default"])(value) !== 'object' || Array.isArray(value)) return false;
  var proto = Object.getPrototypeOf(value);
  return proto === null || proto === Object.prototype;
};

/**
 * An own, ordinary property, whatever the key. Assignment would not do: `copy.__proto__ = value`
 * sets the copy's prototype, so a regex group named __proto__ vanished from every copy. The copy
 * keeps Object.prototype, so a whole groups object still displays as [object Object].
 */
var defineOwn = function defineOwn(object, key, value) {
  Object.defineProperty(object, key, {
    value: value,
    enumerable: true,
    writable: true,
    configurable: true
  });
};
var mapObject = function mapObject(object, fn) {
  var mapped = {};
  Object.keys(object).forEach(function (key) {
    return defineOwn(mapped, key, fn(object[key]));
  });
  return mapped;
};

/**
 * Array.prototype.map, keeping a match array's metadata: map drops index, input and groups, which
 * is why REFERENCE(REGEXMATCH(...,TRUE),"index") was undefined. input and each group go through fn,
 * so a copy that unwraps or tags elements does the same to them. map keeps the MultiValue subclass
 * (Symbol.species), so collapseMultiValue still recognises it.
 */
var mapArray = function mapArray(array, fn) {
  var mapped = array.map(function (item) {
    return fn(item);
  });
  if (isMatchArray(array)) {
    mapped.index = array.index;
    mapped.input = fn(array.input);
    mapped.groups = array.groups === undefined ? undefined : mapObject(array.groups, fn);
  }
  return mapped;
};

//Array or plain object, element by element; anything else is left to fn's caller
var mapDeep = function mapDeep(value, fn) {
  if (Array.isArray(value)) return mapArray(value, fn);
  if (isPlainObject(value)) return mapObject(value, fn);
  return value;
};
var unwrapDeep = function unwrapDeep(value) {
  if (value instanceof AmbiguousText) return value.text;
  return mapDeep(value, unwrapDeep);
};
var deriveDeep = function deriveDeep(value) {
  if (value instanceof AmbiguousText) return value.derived ? value : new AmbiguousText(value.text, {
    derived: true
  });
  return mapDeep(value, deriveDeep);
};

//A string built from tagged text is still tagged, as derived. Clean numbers ("10" from LEFT(A,2))
//and every non-string result pass through untouched, so extracting digits from text keeps working.
var retagAmbiguous = function retagAmbiguous(result) {
  if (typeof result === 'string') return isAmbiguousText(result) ? new AmbiguousText(result, {
    derived: true
  }) : result;
  return mapDeep(result, retagAmbiguous);
};

//An empty cell anywhere inside a value (elements only)
var hasBlank = function hasBlank(value) {
  return value === BLANK || Array.isArray(value) && value.some(hasBlank);
};

/**
 * Whether a value carries anything a copy must preserve or a provenance rule may need: a tag
 * (element or metadata), a blank cell, or either inside a groups object. Decides whether a frame
 * keeps its original arguments and whether an argument is copied before the built-in runs. Never
 * used to judge a value: that is forEachLeaf, elements only.
 */
var hasMarker = function hasMarker(value) {
  if (value instanceof AmbiguousText || value === BLANK || isCellDate(value)) return true;
  if (Array.isArray(value)) {
    if (value.some(hasMarker)) return true;
    return isMatchArray(value) && (hasMarker(value.input) || value.groups !== undefined && hasMarker(value.groups));
  }
  if (isPlainObject(value)) return Object.keys(value).some(function (key) {
    return hasMarker(value[key]);
  });
  return false;
};

/**
 * A multiSelect is a set of values for an argument that reads a number, so SUM adds every
 * selection, and its displayed text for an argument that reads text, so CONCATENATE and LEN
 * see exactly the string the cell shows. This collapses it for the second case, walking
 * nested ranges too.
 */
var collapseMultiValue = function collapseMultiValue(value) {
  if (value instanceof MultiValue) return String(value);
  return mapDeep(value, collapseMultiValue);
};
var collapseMultiValues = function collapseMultiValues(params) {
  return params.map(collapseMultiValue);
};

/**
 * collapseMultiValue for a position that keeps its tags: when any selection was tagged, the
 * collapsed string keeps a derived tag, so "Option 1, Option 2" still cannot pose as a number.
 */
var collapseTagged = function collapseTagged(value) {
  if (value instanceof MultiValue) {
    var text = String(value);
    return hasTagLeaf(value) && isAmbiguousText(text) ? new AmbiguousText(text, {
      derived: true
    }) : text;
  }
  return mapDeep(value, collapseTagged);
};

/**
 * Operators that read their operands as values to compare or join, never as numbers.
 *
 * Arithmetic is deliberately absent: a wrapped value must still make + - * / ^ throw, which is
 * the entire reason AmbiguousText is an object. These are the exact names the grammar
 * dispatches, confirmed by instrumenting yy.evaluateByOperator on the bundled parser. Unary
 * minus does not come through there at all.
 */
var VALUE_OPERATORS = new Set(['=', '<>', '>', '<', '>=', '<=', '&']);
var RANK_FUNCTIONS = new Set(['RANK.EQ', 'RANK.AVG', 'RANKEQ', 'RANKAVG']);
var unwrapOperand = function unwrapOperand(value) {
  if (value instanceof AmbiguousText) return value.text;
  if (value === BLANK) return '';
  if (isCellDate(value)) return value.getTime();
  return collapseMultiValue(value);
};

/**
 * Throws when a tag reaches an argument that reads a number, and hands the plain string back when
 * it reaches one that reads text: formulajs checks typeof === 'string', so an unwrapped LEN() or
 * UPPER() would fail on the wrapper itself. Also collapses a multiSelect holding several
 * selections to its displayed string wherever an argument reads text, so LEN and CONCATENATE see
 * the string the cell shows while SUM keeps the set.
 *
 * Each tag is judged on its own, wherever it sits (a scalar, a range, a nested array, a
 * multiSelect), and nothing is unwrapped until every tag in the argument has passed. No verdict
 * depends on a neighbouring tag, or on whether the argument as a whole came from a cell:
 *
 *   - a number position rejects every tag, direct or derived (a derived one is the reviewer's fix)
 *   - a derived tag at a text position is unwrapped with no further checks, as its plain string
 *     was before
 *   - a direct tag at a regex position is refused, as it always was
 *   - a direct tag at a newly admitted position must pass that position's shape check and
 *     LIMITS.textArgLength
 *
 * An argument the function may hand back unchanged (isPassThrough) keeps its tags, turned
 * derived: after this call, before this change, the value was a plain string.
 *
 * Replaces params entries in place (the entries, never the caller's arrays). hot-formula-parser
 * emits 'callFunction' with the same array it then passes to the built-in, so the replacement is
 * what the function actually receives. The one exception is CONCAT: createParser registers it
 * with setFunction, and _callFunction runs a custom function BEFORE emitting, so CONCAT never
 * reaches this hook. An AmbiguousText wrapper survives that because its join() stringifies
 * correctly, but a MultiValue does not, so CONCAT calls collapseMultiValues itself.
 */
var resolveAmbiguousArgs = function resolveAmbiguousArgs(name) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var upperName = String(name).toUpperCase();
  params.forEach(function (param, index) {
    var policy = positionPolicy(upperName, index);

    //Handed back as is, so an empty cell stays one too: IF(TRUE,A,0)+1 reads it as 0, as A+1 does
    if (isPassThrough(upperName, index, params.length, param)) {
      params[index] = deriveDeep(policy.readsText ? collapseTagged(param) : param);
      return;
    }

    //An argument past the count the function declares is never read by it (FormulaFixedArity lists
    //only functions that do not touch `arguments`). Derived text there was a plain string before and
    //changed nothing, so it still passes; direct cell text there was refused before, and still is.
    var fixedArity = _FormulaFixedArity["default"][upperName];
    var ignored = fixedArity !== undefined && index >= fixedArity;

    //Phase 1: judge every leaf. Nothing is changed yet.
    forEachLeaf(param, function (leaf) {
      if (!policy.readsText) {
        if (leaf.derived && ignored) return;
        throw new Error("".concat(name, ": argument ").concat(index + 1, " is text, not a number"));
      }
      if (leaf.derived) return;
      if (!policy.directAllowed) throw new Error("".concat(name, ": argument ").concat(index + 1, " does not take text from a cell"));
      if (policy.newlyAdmitted) {
        if (String(leaf.text).length > LIMITS.textArgLength) throw new Error("".concat(name, ": argument ").concat(index + 1, " is too long"));
        if (policy.accepts && !policy.accepts(leaf.text)) throw new Error("".concat(name, ": argument ").concat(index + 1, " is not valid"));
      }
    });

    //Phase 2: every leaf passed, so unwrap the whole structure (a copy, match metadata included),
    //then settle empty cells the way this position reads them.
    var value = hasMarker(param) ? unwrapDeep(param) : param;
    var collapsed = policy.readsText ? collapseMultiValue(value) : value;
    var settled = settleBlanks(collapsed, blankPolicy(upperName, index, policy, params));
    params[index] = coerceCellDates(settled, isCellDatePosition(upperName, index), isCellDateListPosition(upperName, index));
  });
};

// ---------------------------------------------------------------------------
// Provenance: whether a tagged argument's text reached a function's result
// ---------------------------------------------------------------------------

/**
 * For functions that build text from their arguments: whether argument `index` can put characters
 * into the result. A tag is never empty, so "is copied in" means "contributes", and an argument past
 * a fixed-arity function's declared count never does (isReadArgument). A function absent
 * from this table never re-tags its result, so it behaves exactly as before. IF, CHOOSE, SWITCH and
 * ARGS2ARRAY are absent on purpose: they hand the tagged object itself back (isPassThrough).
 */
var ARG0_ONLY = function ARG0_ONLY(index) {
  return index === 0;
};
var ARG0_WHEN_SCALAR = function ARG0_WHEN_SCALAR(index, args) {
  return index === 0 && !Array.isArray(args[0]);
}; // array args pass through
var EVERY_ARG = function EVERY_ARG() {
  return true;
};
var CONTRIBUTORS = _objectSpread({
  LEFT: ARG0_ONLY,
  RIGHT: ARG0_ONLY,
  MID: ARG0_ONLY,
  TRIM: ARG0_ONLY,
  UPPER: ARG0_ONLY,
  LOWER: ARG0_ONLY,
  PROPER: ARG0_ONLY,
  CLEAN: ARG0_ONLY,
  HTML2TEXT: ARG0_ONLY,
  T: ARG0_ONLY,
  REPT: ARG0_ONLY,
  REGEXEXTRACT: ARG0_ONLY,
  // returns a match, a piece of arg 0
  SPLIT: ARG0_ONLY,
  // pieces of arg 0; the separator never appears
  FLATTEN: ARG0_WHEN_SCALAR,
  // a string arg 0 is split into its characters
  TRANSPOSE: ARG0_WHEN_SCALAR,
  CONCATENATE: EVERY_ARG,
  CONCAT: EVERY_ARG,
  //array.join(separator): every element, and the separator only between two or more elements
  JOIN: function JOIN(index, args) {
    return index === 0 || index === 1 && Array.isArray(args[0]) && args[0].length >= 2;
  },
  //text.match(regex): the match, its captures, input and groups are all pieces of argument 0
  REGEXMATCH: ARG0_ONLY
}, Object.fromEntries(Object.keys(DIRECT_TEXT_ARGS).filter(function (name) {
  return [isComplexText, isImaginaryUnit].includes(DIRECT_TEXT_ARGS[name].accepts);
}).map(function (name) {
  return [name, EVERY_ARG];
})));

/**
 * Only an argument the function reads can put characters into its result. FormulaFixedArity lists
 * how many arguments a fixed-arity function declares; one past that is ignored by the built-in
 * (IMCONJUGATE("3+4i",TRIM(A)) is 3-4i whatever A holds), so it never contributes. The argument
 * hook ignores such arguments by the same table.
 */
var isReadArgument = function isReadArgument(name, index) {
  var fixedArity = _FormulaFixedArity["default"][name];
  return fixedArity === undefined || index < fixedArity;
};
var UNKNOWN_PROVENANCE = 'unknown';

//UNIQUE keeps the first argument === to each value, in argument order. Tag an output element only
//if that first occurrence was tagged, and hand an empty cell back as one; array outputs already
//carry their own tags and blanks.
var retagUniqueByFirstOccurrence = function retagUniqueByFirstOccurrence(frame, args, result) {
  if (!Array.isArray(result)) return result;
  return result.map(function (element) {
    if (typeof element !== 'string') return element;
    var first = args.findIndex(function (arg) {
      return arg === element;
    });
    if (first === -1) return element;
    if (frame.original[first] === BLANK) return BLANK;
    return frame.tagged[first] ? retagAmbiguous(element) : element;
  });
};

/**
 * The path REFERENCE follows, walked through its first argument as it arrived, one property access
 * at a time: `name[index]` is two accesses, as in the built-in. Before an access into a tag, a
 * multiSelect or an empty cell, the walk continues in the text the built-in received for it (the
 * hook unwrapped, collapsed or settled it). `throughTag` says whether the walk went through a
 * tagged value's text. Provenance comes from this structure only, never from comparing texts.
 */
var walkReference = function walkReference(original, path) {
  var node = original;
  var throughTag = false;
  var access = function access(key) {
    if (node instanceof AmbiguousText) {
      throughTag = true;
      node = node.text;
    } else if (node === BLANK) {
      node = '';
    } else if (isCellDate(node)) {
      node = node.getTime(); // the built-in received the epoch number
    } else if (node instanceof MultiValue) {
      throughTag = throughTag || hasTagLeaf(node);
      node = String(node);
    }
    node = node[key];
  };
  if (typeof path !== 'string') return {
    node: undefined,
    throughTag: throughTag,
    failed: true
  };
  try {
    path.split('.').forEach(function (step) {
      if (step[step.length - 1] === ']') {
        var opening = step.indexOf('[');
        access(step.substring(0, opening));
        access(step.substring(opening + 1, step.length - 1));
      } else {
        access(step);
      }
    });
  } catch (e) {
    return {
      node: undefined,
      throughTag: throughTag,
      failed: true
    };
  }
  return {
    node: node,
    throughTag: throughTag,
    failed: false
  };
};

/**
 * The built-in's result, with every tag and empty cell the original held at the same place put
 * back. A multiSelect reached the built-in as its display string; that string carries the labels'
 * text, so it is tagged when any label was.
 */
var restoreFrom = function restoreFrom(original, result) {
  if (original instanceof AmbiguousText) return retagAmbiguous(result);
  if (original === BLANK) return result === '' ? BLANK : result;
  if (isCellDate(original)) return result === original.getTime() ? original : result;
  if (original instanceof MultiValue) return hasTagLeaf(original) ? retagAmbiguous(result) : result;
  if (Array.isArray(original) && Array.isArray(result)) {
    var restored = result.map(function (item, index) {
      return restoreFrom(original[index], item);
    });
    if (isMatchArray(original) && isMatchArray(result)) {
      restored.index = result.index;
      restored.input = restoreFrom(original.input, result.input);
      restored.groups = restoreFrom(original.groups, result.groups);
    }
    return restored;
  }
  if (isPlainObject(original) && isPlainObject(result)) {
    var _restored = {};
    Object.keys(result).forEach(function (key) {
      return defineOwn(_restored, key, restoreFrom(original[key], result[key]));
    });
    return _restored;
  }
  return result;
};
var restoreReference = function restoreReference(frame, args, result) {
  var walked = walkReference(frame.original[0], args[1]);
  //The built-in failed the same way and returned undefined
  if (walked.failed) return result;
  if (walked.throughTag) return retagAmbiguous(result);
  return restoreFrom(walked.node, result);
};
var applyProvenance = function applyProvenance(frame, args, result) {
  //Selectors hand back part of an argument: restore what the original held there, tags and empty
  //cells alike, whether or not any element was tagged
  if (frame.name === 'REFERENCE') return frame.original ? restoreReference(frame, args, result) : result;
  if (frame.name === 'UNIQUE') return frame.original ? retagUniqueByFirstOccurrence(frame, args, result) : result;
  if (!frame.tagged.some(Boolean)) return result;
  if (frame.provenance === UNKNOWN_PROVENANCE) return retagAmbiguous(result);
  if (Array.isArray(frame.provenance)) {
    return frame.provenance.some(function (index) {
      return frame.tagged[index];
    }) ? retagAmbiguous(result) : result;
  }
  var contributes = CONTRIBUTORS[frame.name];
  if (!contributes) return result;
  return frame.tagged.some(function (tagged, index) {
    return tagged && isReadArgument(frame.name, index) && contributes(index, args);
  }) ? retagAmbiguous(result) : result;
};

// ---------------------------------------------------------------------------
// Instrumented replacement functions
// ---------------------------------------------------------------------------

/**
 * String.prototype.replace's GetSubstitution for one match, also reporting where the characters
 * came from: `fromReplacement` when a literal character of the replacement was emitted, `fromSource`
 * when a $ form echoed text of the subject ($&, $`, $', $n, $<name>).
 */
var getSubstitution = function getSubstitution(replacement, matched, subject, position, captures, groups) {
  var output = '';
  var fromReplacement = false;
  var fromSource = false;
  var literal = function literal(text) {
    if (text) {
      output += text;
      fromReplacement = true;
    }
  };
  var echo = function echo(text) {
    if (text) {
      output += text;
      fromSource = true;
    }
  };
  var isDigit = function isDigit(_char3) {
    return _char3 >= '0' && _char3 <= '9';
  };
  var i = 0;
  while (i < replacement.length) {
    var _char4 = replacement.charAt(i);
    var next = replacement.charAt(i + 1);
    if (_char4 !== '$' || i + 1 >= replacement.length) {
      literal(_char4);
      i += 1;
    } else if (next === '$') {
      literal('$');
      i += 2;
    } else if (next === '&') {
      echo(matched);
      i += 2;
    } else if (next === '`') {
      echo(subject.slice(0, position));
      i += 2;
    } else if (next === "'") {
      echo(subject.slice(Math.min(position + matched.length, subject.length)));
      i += 2;
    } else if (isDigit(next)) {
      var after = replacement.charAt(i + 2);
      var twoDigits = isDigit(after) ? parseInt("".concat(next).concat(after), 10) : NaN;
      var oneDigit = parseInt(next, 10);
      if (twoDigits >= 1 && twoDigits <= captures.length) {
        echo(captures[twoDigits - 1] === undefined ? '' : captures[twoDigits - 1]);
        i += 3;
      } else if (oneDigit >= 1 && oneDigit <= captures.length) {
        echo(captures[oneDigit - 1] === undefined ? '' : captures[oneDigit - 1]);
        i += 2;
      } else {
        literal('$');
        i += 1;
      }
    } else if (next === '<') {
      var close = groups === undefined ? -1 : replacement.indexOf('>', i + 2);
      if (close === -1) {
        literal('$<');
        i += 2;
      } else {
        var capture = groups[replacement.slice(i + 2, close)];
        if (capture !== undefined) echo(String(capture));
        i = close + 1;
      }
    } else {
      literal('$');
      i += 1;
    }
  }
  return {
    output: output,
    fromReplacement: fromReplacement,
    fromSource: fromSource
  };
};

/**
 * text.replace(regex, replacement), evaluated through a replacer so each match's expansion is
 * known. The language guarantees a replacer is called for exactly the matches, in the order, that
 * a string replacement would use, and getSubstitution expands like the string form, so the output
 * is the same string (a corpus test holds this).
 */
var replaceTracked = function replaceTracked(text, regex, replacement) {
  var consumed = 0;
  var fromReplacement = false;
  var fromSource = false;
  var output = text.replace(regex, function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var groups = (0, _typeof2["default"])(args[args.length - 1]) === 'object' && args[args.length - 1] !== null ? args.pop() : undefined;
    var subject = args.pop();
    var position = args.pop();
    var matched = args[0],
      captures = args.slice(1);
    consumed += matched.length;
    var expansion = getSubstitution(replacement, matched, subject, position, captures, groups);
    fromReplacement = fromReplacement || expansion.fromReplacement;
    fromSource = fromSource || expansion.fromSource;
    return expansion.output;
  });

  //Unmatched subject text survives into the output
  if (consumed < text.length) fromSource = true;
  return {
    output: output,
    fromReplacement: fromReplacement,
    fromSource: fromSource
  };
};

/**
 * Copies of three formulajs functions (formula-parser.js SUBSTITUTE, REGEXREPLACE, REPLACE), statement
 * for statement, that also report which arguments' characters reached the result. The callFunction
 * hook runs one INSTEAD of the built-in when an argument is tagged, so its regex runs once, as before.
 *
 * Each returns { result, contributes: [argument indexes] }, or null for a shape it does not copy,
 * in which case the built-in runs. Those shapes only produce errors or non-strings: text that is not
 * a string (the built-in throws), a missing argument (#N/A), and a SUBSTITUTE occurrence that is not
 * a positive integer (the built-in's own loop, left exactly as it is).
 */
var INSTRUMENTED_FUNCTIONS = {
  SUBSTITUTE: function SUBSTITUTE(args) {
    var argCount = args.length;
    if (argCount < 2) return null;
    var _args = (0, _slicedToArray2["default"])(args, 4),
      text = _args[0],
      oldText = _args[1],
      newText = _args[2],
      occurrence = _args[3];
    if (!text || !oldText || !newText) return {
      result: text,
      contributes: [0]
    };
    if (typeof text !== 'string') return null;
    if (occurrence === undefined) {
      var tracked = replaceTracked(text, new RegExp(oldText, 'g'), String(newText));
      var contributes = [];
      if (tracked.fromSource) contributes.push(0);
      if (tracked.fromReplacement) contributes.push(2);
      return {
        result: tracked.output,
        contributes: contributes
      };
    }
    if (!Number.isInteger(occurrence) || occurrence < 1) return null;
    var index = 0;
    var i = 0;
    while (text.indexOf(oldText, index) > 0) {
      index = text.indexOf(oldText, index + 1);
      i++;
      if (i === occurrence) {
        var kept = text.substring(0, index) + text.substring(index + oldText.length);
        return {
          result: text.substring(0, index) + newText + text.substring(index + oldText.length),
          contributes: kept.length > 0 ? [0, 2] : [2]
        };
      }
    }
    return null; // not found: the built-in returns undefined and the parser turns that into TRUE
  },
  REGEXREPLACE: function REGEXREPLACE(args) {
    var argCount = args.length;
    if (argCount < 3) return null;
    var _args2 = (0, _slicedToArray2["default"])(args, 3),
      text = _args2[0],
      regularExpression = _args2[1],
      replacement = _args2[2];
    if (typeof text !== 'string') return null;
    var tracked = replaceTracked(text, new RegExp(regularExpression), String(replacement));
    var contributes = [];
    if (tracked.fromSource) contributes.push(0);
    if (tracked.fromReplacement) contributes.push(2);
    return {
      result: tracked.output,
      contributes: contributes
    };
  },
  REPLACE: function REPLACE(args) {
    var _args3 = (0, _slicedToArray2["default"])(args, 4),
      text = _args3[0],
      rawPosition = _args3[1],
      rawLength = _args3[2],
      newText = _args3[3];
    var position = formulajsNumber(rawPosition);
    var length = formulajsNumber(rawLength);
    if (Number.isNaN(position) || Number.isNaN(length) || typeof text !== 'string' || typeof newText !== 'string') return null;
    var before = text.substr(0, position - 1);
    var after = text.substr(position - 1 + length);
    var contributes = [];
    if (before.length + after.length > 0) contributes.push(0);
    if (newText.length > 0) contributes.push(3);
    return {
      result: before + newText + after,
      contributes: contributes
    };
  }
};
var optionLabel = function optionLabel(column, optionId) {
  var option = (column.options || []).find(function (item) {
    return item && item._id === optionId;
  });
  return option ? option.value : '';
};
var optionLabels = function optionLabels(column, optionIds) {
  return Array.isArray(optionIds) ? optionIds.map(function (optionId) {
    return optionLabel(column, optionId);
  }).filter(function (label) {
    return label !== '';
  }) : [];
};

// ---------------------------------------------------------------------------
// The overlay resolver (pass 2)
// ---------------------------------------------------------------------------

/**
 * Resolve every blank text cell under a column formula, and every row-path cell formula
 * (isRowCellFormula) for its own row.
 *
 * @param {Array|String} rows           rows in grid order (deleted rows are dropped here)
 * @param {Array|String} columns        columns in grid order (sortColumns(tableColumns, tableColumnOrder))
 * @param {Object}       legacyLookup   generateTableLookup(rows, columns): stored cell formulas already resolved
 *
 * @returns {Object} overlay keyed by row INDEX then column id: { 0: { columnId: "6" } }.
 *   Keyed by index, never by row id, so two rows sharing an id keep separate results.
 */
var resolveColumnFormulaCells = exports.resolveColumnFormulaCells = function resolveColumnFormulaCells(rows, columns) {
  var legacyLookup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var activeColumns = filterLookupColumns(columns);
  var activeRows = (0, _tableHelper.getRows)(rows);
  var refs = buildReferenceIndex(activeColumns);
  var columnCount = activeColumns.length;
  var cache = new Map();
  //Every cell being evaluated right now, of either engine: a repeat is a cycle
  var stack = new Set();
  //The cells of walks that went deeper than LIMITS.depth and wait for resolveRoot to finish a
  //deeper cell first. They are still being evaluated, logically, so reading one is a cycle too.
  var waiting = new Set();
  var onPath = function onPath(key) {
    return stack.has(key) || waiting.has(key);
  };
  //Only column and row-path cells count toward LIMITS.depth, as before. Dirty A1 cells are walked
  //iteratively (evaluateDirtyA1), so a long A1 chain costs no reference depth.
  var overlayDepth = 0;
  //Set when a walk goes deeper than LIMITS.depth: the cell it could not enter and the path to it.
  //While unwinding, nothing starts and nothing is cached until resolveRoot catches the overflow.
  var frontier = null;
  var unwinding = false;
  var current = {
    rowIndex: 0
  };
  var deadline = Date.now() + LIMITS.softTimeBudgetMs;
  //Time spent evaluating dirty A1 cells, credited back so they never take budget from the column
  //formulas that had it all before
  var a1Credit = 0;
  var budgetWarned = false;
  var convergenceReported = false;
  var pastDeadline = function pastDeadline() {
    return Date.now() - a1Credit > deadline;
  };

  //Past the soft budget a cell is an explicit Error, never a value read before its inputs existed
  var budgetSpent = function budgetSpent() {
    if (!budgetWarned) {
      budgetWarned = true;
      // eslint-disable-next-line no-console
      console.warn("Column formula resolution exceeded ".concat(LIMITS.softTimeBudgetMs, "ms; remaining cells report ").concat(FORMULA_ERROR, "."));
    }
    return FORMULA_ERROR;
  };
  var parser = createParser();
  var resolveCell;
  var inBounds = function inBounds(rowIndex, colIndex) {
    return rowIndex >= 0 && rowIndex < activeRows.length && colIndex >= 0 && colIndex < columnCount;
  };
  var rawAt = function rawAt(rowIndex, colIndex) {
    var row = activeRows[rowIndex];
    return row && row.cells ? row.cells[activeColumns[colIndex]._id] : undefined;
  };

  //Classified once per call. scopeValue asks for every referenced cell, including every cell of
  //every range, so re-running the shape scan there would spend the soft time budget, and running
  //out of it shows typed text: slowness here would be user-visible.
  var rowFormulaKeys = new Set();
  activeRows.forEach(function (row, rowIndex) {
    return activeColumns.forEach(function (column, colIndex) {
      if (isRowCellFormula(rawAt(rowIndex, colIndex), column)) rowFormulaKeys.add(rowIndex * columnCount + colIndex);
    });
  });
  var isRowFormulaCell = function isRowFormulaCell(rowIndex, colIndex) {
    return rowFormulaKeys.has(rowIndex * columnCount + colIndex);
  };

  /**
   * The formula a cell evaluates: its own row-path formula, else its column's (blank cells only).
   */
  var formulaAt = function formulaAt(rowIndex, colIndex) {
    return isRowFormulaCell(rowIndex, colIndex) ? rawAt(rowIndex, colIndex) : getColumnFormula(activeColumns[colIndex]);
  };

  /** Cells whose value this resolver produces. */
  var isOverlayCell = function isOverlayCell(rowIndex, colIndex) {
    return isRowFormulaCell(rowIndex, colIndex) || !!getColumnFormula(activeColumns[colIndex]) && isBlankCell(rawAt(rowIndex, colIndex));
  };
  var cellKeyOf = function cellKeyOf(rowIndex, colIndex) {
    return "".concat(rowIndex, ":").concat(colIndex);
  };
  var operandOf = function operandOf(rowIndex, colIndex) {
    return "".concat((0, _tableHelper.getColumnOperand)(colIndex)).concat(rowIndex + 1);
  };
  var cellOf = function cellOf(operand) {
    var colIndex = operand.charCodeAt(0) - 65;
    var rowIndex = parseInt(operand.slice(1), 10) - 1;
    return inBounds(rowIndex, colIndex) ? {
      rowIndex: rowIndex,
      colIndex: colIndex
    } : null;
  };

  //The cell engine's formula cells that are not overlay cells, with the addresses each one reads,
  //and the reverse map. Both come from the cell engine's own rules (getLegacyFormula,
  //getLegacyOperands), so this sees exactly the dependencies getFormulaResult follows.
  var a1Formulas = new Map();
  var a1Operands = new Map();
  var dependents = new Map();
  activeRows.forEach(function (row, rowIndex) {
    return activeColumns.forEach(function (column, colIndex) {
      if (isOverlayCell(rowIndex, colIndex)) return;
      var formula = (0, _tableHelper.getLegacyFormula)(rawAt(rowIndex, colIndex), column);
      if (!formula) return;
      var self = operandOf(rowIndex, colIndex);
      var inputs = (0, _tableHelper.getLegacyOperands)(formula).filter(function (operand) {
        return cellOf(operand);
      });
      a1Formulas.set(self, formula);
      a1Operands.set(self, inputs);
      inputs.forEach(function (input) {
        if (!dependents.has(input)) dependents.set(input, []);
        dependents.get(input).push(self);
      });
    });
  });

  //Dirty A1 cells: those whose inputs, followed through other A1 cells, reach an overlay cell. Only
  //these can be stale in the pass-1 lookup; every other A1 cell keeps reading pass 1, exactly as
  //before. One visit per input address.
  var dirtyA1 = new Set();
  var dirtyQueue = [];
  activeRows.forEach(function (row, rowIndex) {
    return activeColumns.forEach(function (column, colIndex) {
      if (isOverlayCell(rowIndex, colIndex)) dirtyQueue.push(operandOf(rowIndex, colIndex));
    });
  });
  while (dirtyQueue.length) {
    (dependents.get(dirtyQueue.pop()) || []).forEach(function (cell) {
      if (!dirtyA1.has(cell)) {
        dirtyA1.add(cell);
        dirtyQueue.push(cell);
      }
    });
  }

  /**
   * The value a formula sees when it references a cell.
   */
  var scopeValue = function scopeValue(rowIndex, colIndex) {
    var column = activeColumns[colIndex];
    var raw = rawAt(rowIndex, colIndex);

    //Resolved here, so =c*2 can read =a+f in the same row
    if (isRowFormulaCell(rowIndex, colIndex)) return asScopeNumber(resolveCell(rowIndex, colIndex));
    if (getColumnFormula(column) && isBlankCell(raw)) return asScopeNumber(resolveCell(rowIndex, colIndex));

    //isCellFormula, not isFormulaString: "= SUM(A1+B1)" is a cell-level formula, so read its result.
    //A dirty one is resolved now: pass 1 computed it before the overlay results it reads existed.
    if (isCellFormula(raw)) {
      var operand = operandOf(rowIndex, colIndex);
      return asScopeNumber(dirtyA1.has(operand) ? resolveCell(rowIndex, colIndex) : legacyLookup[operand]);
    }

    //Nothing selected is an empty cell, like a blank text cell
    if (column.type === _FieldTableColumnTypes["default"].dropdown) return isBlankCell(raw) ? BLANK : asScopeNumber(optionLabel(column, raw));
    if (column.type === _FieldTableColumnTypes["default"].multiSelect) {
      var values = optionLabels(column, raw).map(asScopeNumber);
      if (values.length === 0) return isBlankCell(raw) || Array.isArray(raw) && raw.length === 0 ? BLANK : '';
      //One selection stays scalar so =E+1 keeps working: aggregates take arrays but the
      //operators do not. Only a genuine set becomes a MultiValue, and scalar arithmetic on a
      //set is an error, as it should be.
      if (values.length === 1) return values[0];
      return MultiValue.of.apply(MultiValue, (0, _toConsumableArray2["default"])(values));
    }
    if (isBlankCell(raw)) return column.type === _FieldTableColumnTypes["default"].number ? 0 : BLANK;

    //Every column whose value is a string goes through asScopeNumber, not just text: a dropdown
    //label or a barcode is just as non-numeric. asScopeNumber returns non-strings untouched.
    return asScopeNumber(raw);
  };
  var evaluate = function evaluate(formula, rowIndex) {
    var expression = preprocessFormula(formula, refs);
    var previousRowIndex = current.rowIndex;
    current.rowIndex = rowIndex;
    var parsed;
    try {
      parsed = parser.parse(expression);
    } finally {
      current.rowIndex = previousRowIndex;
    }
    if (parsed.error) return FORMULA_ERROR;

    //A formula that selected an empty cell (=A, =IF(TRUE,A,0)) is one too for the formulas that
    //read it, so splitting a formula across two cells never changes its result. It displays ''.
    if (parsed.result === BLANK) return BLANK;

    //A date stays a date for the formulas that read this cell; it displays as before
    if (parsed.result instanceof Date && !Number.isNaN(parsed.result.getTime())) {
      return isCellDate(parsed.result) ? parsed.result : new CellDate(parsed.result.getTime());
    }
    return normaliseResult(parsed.result);
  };

  /**
   * What the cell engine reads for an overlay cell in pass 3: its result, except a row-path formula
   * that did not evaluate, which shows (and is read as) its typed text.
   */
  var overlayDisplay = function overlayDisplay(rowIndex, colIndex) {
    var value = resolveCell(rowIndex, colIndex);
    if (value === BLANK) return '';
    if (isCellDate(value)) return normaliseResult(value);
    return isRowFormulaCell(rowIndex, colIndex) && value === FORMULA_ERROR ? rawAt(rowIndex, colIndex) : value;
  };

  /**
   * One dirty A1 cell, through the cell engine's own evaluator (getFormulaResult), so its value is
   * the one pass 3 will display. Its inputs come from this resolver first, so none is stale, and
   * the cell sits on the shared stack while they resolve, so a loop through both engines is caught.
   * A view over the pass-1 lookup keeps this O(inputs): reads fall through, writes stay here.
   */
  var evaluateOneA1 = function evaluateOneA1(operand, cyclic) {
    var _cellOf = cellOf(operand),
      rowIndex = _cellOf.rowIndex,
      colIndex = _cellOf.colIndex;
    var key = cellKeyOf(rowIndex, colIndex);
    if (cache.has(key)) return;
    //Still being evaluated further up the path: a loop through both engines
    if (onPath(key)) throw new CycleError();

    //An A1-only loop keeps the cell engine's own circular result ('* INVALID - Circular
    //Reference'), the same text pass 3 displays for it
    if (cyclic) {
      cache.set(key, legacyLookup[operand]);
      return;
    }
    if (pastDeadline()) {
      cache.set(key, budgetSpent());
      return;
    }
    stack.add(key);
    var value;
    try {
      var view = Object.create(legacyLookup);
      //The overlay results this cell reads are data to the cell engine, even text such as "=A1+1"
      var literalInputs = new Set();
      a1Operands.get(operand).forEach(function (input) {
        var cell = cellOf(input);
        if (isOverlayCell(cell.rowIndex, cell.colIndex)) {
          view[input] = overlayDisplay(cell.rowIndex, cell.colIndex);
          //A failed row-path cell shows its stored text, which the cell engine reads as it always did
          var _typedText = isRowFormulaCell(cell.rowIndex, cell.colIndex) && resolveCell(cell.rowIndex, cell.colIndex) === FORMULA_ERROR;
          if (!_typedText) literalInputs.add(input);
        } else if (dirtyA1.has(input)) {
          view[input] = resolveCell(cell.rowIndex, cell.colIndex);
        }
      });
      var started = Date.now();
      (0, _tableHelper.getFormulaResult)(operand, a1Formulas.get(operand), view, literalInputs);
      a1Credit += Date.now() - started;
      value = view[operand];
    } catch (e) {
      //Too deep through overlay cells below: resolveRoot finishes the deeper cell and retries, so
      //nothing is cached for this one yet
      if (e instanceof DepthExceeded) throw e;
      value = FORMULA_ERROR; // a loop through both engines (CycleError)
    } finally {
      stack["delete"](key);
    }
    cache.set(key, value);
  };

  /**
   * The dirty A1 cells `root` depends on, not yet cached, in the order to evaluate them (inputs
   * first), each marked cyclic when it sits in an A1-only loop. Tarjan's strongly connected
   * components with an explicit stack: no recursion, however long the chain.
   */
  var orderDirtyCone = function orderDirtyCone(root) {
    var indexOf = new Map();
    var lowOf = new Map();
    var onStack = new Set();
    var componentStack = [];
    var ordered = [];
    var counter = 0;
    var inputsOf = function inputsOf(operand) {
      return a1Operands.get(operand).filter(function (input) {
        if (!dirtyA1.has(input)) return false;
        var cell = cellOf(input);
        return !cache.has(cellKeyOf(cell.rowIndex, cell.colIndex));
      });
    };
    var work = [{
      operand: root,
      inputs: null,
      next: 0
    }];
    while (work.length) {
      var frame = work[work.length - 1];
      if (frame.inputs === null) {
        indexOf.set(frame.operand, counter);
        lowOf.set(frame.operand, counter);
        counter += 1;
        componentStack.push(frame.operand);
        onStack.add(frame.operand);
        frame.inputs = inputsOf(frame.operand);
      }
      if (frame.next < frame.inputs.length) {
        var input = frame.inputs[frame.next];
        frame.next += 1;
        if (!indexOf.has(input)) work.push({
          operand: input,
          inputs: null,
          next: 0
        });else if (onStack.has(input)) lowOf.set(frame.operand, Math.min(lowOf.get(frame.operand), indexOf.get(input)));
      } else {
        work.pop();
        if (work.length) {
          var parent = work[work.length - 1];
          lowOf.set(parent.operand, Math.min(lowOf.get(parent.operand), lowOf.get(frame.operand)));
        }
        if (lowOf.get(frame.operand) === indexOf.get(frame.operand)) {
          (function () {
            var members = [];
            var member = void 0;
            do {
              member = componentStack.pop();
              onStack["delete"](member);
              members.push(member);
            } while (member !== frame.operand);
            var cyclic = members.length > 1 || frame.inputs.includes(frame.operand);
            members.forEach(function (operand) {
              return ordered.push({
                operand: operand,
                cyclic: cyclic
              });
            });
          })();
        }
      }
    }
    return ordered;
  };
  var evaluateDirtyA1 = function evaluateDirtyA1(rowIndex, colIndex) {
    var key = cellKeyOf(rowIndex, colIndex);
    if (onPath(key)) throw new CycleError();
    orderDirtyCone(operandOf(rowIndex, colIndex)).forEach(function (_ref2) {
      var operand = _ref2.operand,
        cyclic = _ref2.cyclic;
      return evaluateOneA1(operand, cyclic);
    });
    return cache.get(key);
  };
  resolveCell = function resolveCell(rowIndex, colIndex) {
    //An overflow is being carried up to resolveRoot: start nothing, cache nothing
    if (unwinding) throw new DepthExceeded();
    var key = cellKeyOf(rowIndex, colIndex);
    if (cache.has(key)) return cache.get(key);
    if (dirtyA1.has(operandOf(rowIndex, colIndex)) && !isOverlayCell(rowIndex, colIndex)) return evaluateDirtyA1(rowIndex, colIndex);
    if (pastDeadline()) {
      var spent = budgetSpent();
      cache.set(key, spent);
      return spent;
    }
    if (onPath(key)) throw new CycleError();
    if (overlayDepth > LIMITS.depth) {
      //Carried up to resolveRoot, which resolves this cell first and then retries. The parser
      //turns any throw into an error result, so the flag carries it through each enclosing parse.
      frontier = {
        rowIndex: rowIndex,
        colIndex: colIndex,
        path: (0, _toConsumableArray2["default"])(stack)
      };
      unwinding = true;
      throw new DepthExceeded();
    }
    stack.add(key);
    overlayDepth += 1;
    var value;
    try {
      value = evaluate(formulaAt(rowIndex, colIndex), rowIndex);
    } catch (e) {
      value = FORMULA_ERROR;
    } finally {
      stack["delete"](key);
      overlayDepth -= 1;
    }

    //Not cached: this cell is fine, it was cut short by the overflow being carried up
    if (unwinding) throw new DepthExceeded();
    cache.set(key, value);
    return value;
  };

  //Each iteration either caches a cell or schedules one that is uncached and not on the logical
  //path, so this many iterations is always enough. Passing it means the argument is wrong, and
  //the root reports Error instead of hanging.
  var convergenceBound = function convergenceBound() {
    return convergenceBoundOverride !== null ? convergenceBoundOverride : 2 * activeRows.length * columnCount + 2;
  };
  var probe = {
    iterations: 0,
    maxPending: 0,
    bound: 0
  };

  /**
   * Resolve one cell to the end, however long the chain below it. A walk recurses through at most
   * LIMITS.depth overlay cells; when it would go deeper, the cell it could not enter is resolved
   * first, from depth 0, and the walk is retried. The aborted path waits meanwhile, so the cycle
   * check sees the same call stack an unlimited walk would. What the aborted walk finished stays
   * cached, so every retry goes further, and a deterministic value is the one an unlimited walk
   * gives.
   */
  var resolveRoot = function resolveRoot(rowIndex, colIndex) {
    var pending = [{
      rowIndex: rowIndex,
      colIndex: colIndex,
      path: null
    }];
    var bound = convergenceBound();
    var iterations = 0;
    try {
      while (pending.length) {
        iterations += 1;
        if (iterations > bound) throw new ConvergenceError();
        var cell = pending[pending.length - 1];
        try {
          resolveCell(cell.rowIndex, cell.colIndex);
          pending.pop();
          if (cell.path) cell.path.forEach(function (key) {
            return waiting["delete"](key);
          });
        } catch (e) {
          if (!(e instanceof DepthExceeded)) throw e;
          unwinding = false;
          var deeper = frontier;
          frontier = null;
          deeper.path.forEach(function (key) {
            return waiting.add(key);
          });
          pending.push(deeper);
          probe.maxPending = Math.max(probe.maxPending, pending.length);
        }
      }
      return resolveCell(rowIndex, colIndex);
    } catch (e) {
      if (!(e instanceof ConvergenceError)) throw e;
      if (!convergenceReported) {
        convergenceReported = true;
        // eslint-disable-next-line no-console
        console.error("Column formula resolution did not converge at row ".concat(rowIndex + 1, ", column ").concat(colIndex + 1, " after ").concat(bound, " steps; it reports ").concat(FORMULA_ERROR, "."));
      }
      //Only the root: every unfinished cell below it was never cached (unwinding), and every
      //finished one is correct
      cache.set(cellKeyOf(rowIndex, colIndex), FORMULA_ERROR);
      return FORMULA_ERROR;
    } finally {
      //The scheduling state this root owns, restored on every exit
      pending.forEach(function (cell) {
        if (cell.path) cell.path.forEach(function (key) {
          return waiting["delete"](key);
        });
      });
      unwinding = false;
      frontier = null;
      probe.iterations = Math.max(probe.iterations, iterations);
      probe.bound = bound;
    }
  };
  parser.on('callVariable', function (name, done) {
    var index = lookupColumn(refs, name, columnCount);
    if (index !== null) done(scopeValue(current.rowIndex, index));
  });
  parser.on('callCellValue', function (_ref3, done) {
    var row = _ref3.row,
      column = _ref3.column;
    if (!isLetterAddressable(column.index)) throw new Error('unsupported column letter');
    //Outside the table is an empty cell
    done(inBounds(row.index, column.index) ? scopeValue(row.index, column.index) : BLANK);
  });
  parser.on('callRangeValue', function (start, end, done) {
    if (!isLetterAddressable(end.column.index)) throw new Error('unsupported column letter');
    var cells = (end.row.index - start.row.index + 1) * (end.column.index - start.column.index + 1);
    if (cells > LIMITS.rangeCells) throw new Error('range too large');
    var values = [];
    for (var r = start.row.index; r <= end.row.index; r++) {
      var rowValues = [];
      for (var c = start.column.index; c <= end.column.index; c++) {
        rowValues.push(inBounds(r, c) ? scopeValue(r, c) : BLANK);
      }
      values.push(rowValues);
    }
    done(values);
  });
  var overlay = {};
  var typedText = new Set();
  typedTextFallbacks.set(overlay, typedText);
  activeRows.forEach(function (row, rowIndex) {
    activeColumns.forEach(function (column, colIndex) {
      var raw = rawAt(rowIndex, colIndex);
      var rowFormula = isRowFormulaCell(rowIndex, colIndex);
      if (!rowFormula && !(getColumnFormula(column) && isBlankCell(raw))) return;
      var value = resolveRoot(rowIndex, colIndex);
      if (!overlay[rowIndex]) overlay[rowIndex] = {};

      //A row-path cell whose "=" text does not evaluate keeps showing what was typed, as it did
      //before this change. Only the display falls back: a row-path or column formula reading this
      //cell gets Error (the cached resolveCell value), and a cell-level formula reading it gets, in
      //pass 3, the same typed text it read before, so it keeps its old result (#NAME?).
      if (value === BLANK) overlay[rowIndex][column._id] = '';else if (isCellDate(value)) overlay[rowIndex][column._id] = normaliseResult(value);else if (rowFormula && value === FORMULA_ERROR) {
        overlay[rowIndex][column._id] = raw;
        typedText.add("".concat(rowIndex, ":").concat(column._id));
      } else {
        overlay[rowIndex][column._id] = value;
      }
    });
  });

  //Read by the tests only: everything a resolve owns is back to rest when it returns
  lastResolverState = {
    stack: stack.size,
    waiting: waiting.size,
    overlayDepth: overlayDepth,
    unwinding: unwinding,
    frontier: frontier !== null,
    callFrames: parser.jfCallFrames.length,
    iterations: probe.iterations,
    maxPending: probe.maxPending,
    bound: probe.bound
  };
  return overlay;
};

// ---------------------------------------------------------------------------
// Composition with the legacy engine (passes 1 and 3)
// ---------------------------------------------------------------------------

/**
 * Copies of the rows with the overlay results written into the blank cells. Memory only: these
 * copies are handed to the legacy engine so stored cell formulas can read column results, and are
 * then discarded.
 */
var applyOverlay = function applyOverlay(activeRows, overlay) {
  return activeRows.map(function (row, rowIndex) {
    return overlay[rowIndex] ? _objectSpread(_objectSpread({}, row), {}, {
      cells: _objectSpread(_objectSpread({}, row.cells || {}), overlay[rowIndex])
    }) : row;
  });
};

/**
 * The legacy {A1: value} lookup with column formulas layered in. Same shape as generateTableLookup.
 *
 * @param {Array|String} rows     rows in grid order (see getOrderedRows)
 * @param {Array|String} columns  columns in grid order (sortColumns(tableColumns, tableColumnOrder))
 */
/**
 * The A1 addresses of the cells the overlay holds a result for. Pass 3 reads those results as data:
 * written into the rows, a result such as "=A1+1" would otherwise be run as a formula.
 */
var overlayOperands = function overlayOperands(overlay, parsedColumns) {
  var columnIndexes = new Map(filterLookupColumns(parsedColumns).map(function (column, colIndex) {
    return [column._id, colIndex];
  }));
  var typedText = typedTextFallbacks.get(overlay) || new Set();
  var operands = new Set();
  Object.keys(overlay).forEach(function (rowIndex) {
    return Object.keys(overlay[rowIndex]).forEach(function (columnId) {
      //A failed row-path cell's own typed text is its stored value, not a result
      if (typedText.has("".concat(rowIndex, ":").concat(columnId))) return;
      if (columnIndexes.has(columnId)) operands.add("".concat((0, _tableHelper.getColumnOperand)(columnIndexes.get(columnId))).concat(Number(rowIndex) + 1));
    });
  });
  return operands;
};
var composeLookup = function composeLookup(rows, columns) {
  var activeRows = (0, _tableHelper.getRows)(rows);
  var parsedColumns = typeof columns === 'string' ? JSON.parse(columns) : columns || [];
  var legacy = (0, _tableHelper.generateTableLookup)(activeRows, parsedColumns);
  var overlay = resolveColumnFormulaCells(activeRows, parsedColumns, legacy);
  var lookup = Object.keys(overlay).length === 0 ? legacy : (0, _tableHelper.generateTableLookup)(applyOverlay(activeRows, overlay), parsedColumns, overlayOperands(overlay, parsedColumns));
  return {
    activeRows: activeRows,
    overlay: overlay,
    lookup: lookup
  };
};
var getTableLookupWithColumnFormulas = exports.getTableLookupWithColumnFormulas = function getTableLookupWithColumnFormulas(rows, columns) {
  return composeLookup(rows, columns).lookup;
};

/**
 * Display values for every cell, one entry per undeleted row in the order given, keyed by
 * column id. Positional on purpose: a duplicated row id can never move one row's result onto
 * another. Consumers that need to find a row's result from the row itself build
 * Map<rowObject, cells> from this array.
 *
 * There is deliberately no id-keyed variant.
 */
var getResolvedCellsByIndex = exports.getResolvedCellsByIndex = function getResolvedCellsByIndex(rows, columns) {
  var activeColumns = filterLookupColumns(columns);
  var _composeLookup = composeLookup(rows, columns),
    activeRows = _composeLookup.activeRows,
    overlay = _composeLookup.overlay,
    lookup = _composeLookup.lookup;
  return activeRows.map(function (row, rowIndex) {
    var cells = {};
    activeColumns.forEach(function (column, colIndex) {
      var raw = row && row.cells ? row.cells[column._id] : undefined;

      // A column-formula result is read from the overlay itself: the legacy lookup trims every
      // string it is handed, which would turn a result such as " - " into "-".
      if (overlay[rowIndex] && overlay[rowIndex][column._id] !== undefined) {
        cells[column._id] = overlay[rowIndex][column._id];
        return;
      }
      cells[column._id] = getDisplayCellValue(raw, column, lookup["".concat((0, _tableHelper.getColumnOperand)(colIndex)).concat(rowIndex + 1)]);
    });
    return cells;
  });
};

/**
 * Internals exposed for the unit tests only (mixed direct and derived tags cannot be built from a
 * table formula, so the leaf algorithm is tested on hand-built arguments). Not part of the API.
 */
var __testing = exports.__testing = {
  AmbiguousText: AmbiguousText,
  MultiValue: MultiValue,
  resolveAmbiguousArgs: resolveAmbiguousArgs,
  unwrapDeep: unwrapDeep,
  deriveDeep: deriveDeep,
  getSubstitution: getSubstitution,
  INSTRUMENTED_FUNCTIONS: INSTRUMENTED_FUNCTIONS,
  createParser: createParser,
  resolverState: function resolverState() {
    return lastResolverState;
  },
  setConvergenceBound: function setConvergenceBound(bound) {
    convergenceBoundOverride = bound;
  },
  BLANK: BLANK,
  hasTagLeaf: hasTagLeaf,
  hasMarker: hasMarker,
  collapseMultiValue: collapseMultiValue,
  collapseTagged: collapseTagged,
  retagAmbiguous: retagAmbiguous,
  settleBlanks: settleBlanks,
  walkReference: walkReference,
  CellDate: CellDate,
  coerceCellDates: coerceCellDates
};
var _default = exports["default"] = {
  FORMULA_ERROR: FORMULA_ERROR,
  LIMITS: LIMITS,
  CELL_DATE_ARGS: CELL_DATE_ARGS,
  FUNCTION_ARG_CAPS: FUNCTION_ARG_CAPS,
  DIRECT_TEXT_ARGS: DIRECT_TEXT_ARGS,
  DERIVED_TEXT_ARGS: DERIVED_TEXT_ARGS,
  isDateText: isDateText,
  isFormulaString: isFormulaString,
  isCellFormula: isCellFormula,
  isRowCellFormula: isRowCellFormula,
  isBlankCell: isBlankCell,
  getColumnFormula: getColumnFormula,
  getCellEditValue: getCellEditValue,
  shouldCopyColumnDefault: shouldCopyColumnDefault,
  getDisplayCellValue: getDisplayCellValue,
  filterLookupColumns: filterLookupColumns,
  getOrderedRows: getOrderedRows,
  preprocessFormula: preprocessFormula,
  guardFunctionArgs: guardFunctionArgs,
  normaliseResult: normaliseResult,
  resolveColumnFormulaCells: resolveColumnFormulaCells,
  getTableLookupWithColumnFormulas: getTableLookupWithColumnFormulas,
  getResolvedCellsByIndex: getResolvedCellsByIndex
};